import React, { Component, createRef } from "react";
import { addDays, differenceInCalendarDays, format, isBefore } from "date-fns";
import { getSupplierList } from "../../../../lib/getSupplierList";
import cf from "../../../../lib/utils/common";
import B2BWidgets from "../../../b2bwidgets/index";
import DesktopCalender from "../../../calendar/flightCalender/theme7/DesktopCalender";
import MultiSuppilerDropDownoption from "../../../multiDropdown/theme4/index";
import MultiSelectDropDown from "../../../multiSelect/multiSelectDropDown";
import FlightAutoComplete from "./FlightAutoComplete";
import PaxConfig from "./PaxConfig";
import { getUrl, parseurl } from "../../../../lib/flight/urlParser";
import MobileCalender from "../../../calendar/flightCalender/theme7/MobileCalender";
import MulticitySrp from "./MulticitySrp";
import {
  SetRecentSearchFlightlWidget,
  getRecentSearchFlightlWidget,
} from "../../../../../common/lib/searchHomeWidget";
const cabinClass = [
  { id: 1, value: "Economy", label: "Economy" },
  { id: 2, value: "Business", label: "Business" },
  { id: 3, value: "First Class", label: "First Class" },
  { id: 4, value: "Premium Economy", label: "Premium Economy" },
];

const weekday = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

const rbdClass = [
  { label: "All", value: "*", isChecked: false },
  { label: "A", value: "A", isChecked: false },
  { label: "B", value: "B", isChecked: false },
  { label: "C", value: "C", isChecked: false },
  { label: "D", value: "D", isChecked: false },
  { label: "E", value: "E", isChecked: false },
  { label: "F", value: "F", isChecked: false },
  { label: "G", value: "G", isChecked: false },
  { label: "H", value: "H", isChecked: false },
  { label: "I", value: "I", isChecked: false },
  { label: "J", value: "J", isChecked: false },
  { label: "K", value: "K", isChecked: false },
  { label: "L", value: "L", isChecked: false },
  { label: "M", value: "M", isChecked: false },
  { label: "N", value: "N", isChecked: false },
  { label: "O", value: "O", isChecked: false },
  { label: "P", value: "P", isChecked: false },
  { label: "Q", value: "Q", isChecked: false },
  { label: "R", value: "R", isChecked: false },
  { label: "S", value: "S", isChecked: false },
  { label: "T", value: "T", isChecked: false },
  { label: "U", value: "U", isChecked: false },
  { label: "V", value: "V", isChecked: false },
  { label: "W", value: "W", isChecked: false },
  { label: "X", value: "X", isChecked: false },
  { label: "Y", value: "Y", isChecked: false },
  { label: "Z", value: "Z", isChecked: false },
];

let TripType = [
  { id: 1, value: "oneWay", label: "One Way" },
  { id: 2, value: "roundTrip", label: "Round Trip" },
  { id: 3, value: "Multicity", label: "Multicity" },
];

const DepartureTime = [
  { label: "All", value: "All", isChecked: true, code: "All" },
  {
    label: "Before 6 AM",
    value: "Before 6 AM",
    isChecked: false,
    code: "00000559",
  },
  {
    label: "6 AM - 12 PM",
    value: "6 AM - 12 PM",
    isChecked: false,
    code: "06001159",
  },
  {
    label: "12 PM - 6 PM",
    value: "12 PM - 6 PM",
    isChecked: false,
    code: "12001759",
  },
  {
    label: "After 6 PM",
    value: "After 6 PM",
    isChecked: false,
    code: "18002359",
  },
];

let airline = [];
const todaysDate = format(new Date(), "dd-LLL-yyyy");
export default class Theme1 extends Component {
  constructor(props) {
    super(props);
    this.setState = this.setState.bind(this);
    this.guestDetailWrapper = createRef();
    this.economyPopUpWrapper = createRef();
    this.advanceSearchWrapper = createRef();
    this.passengerDropdownWrapper = createRef();
    this.travellerCabin = createRef();
    this.multicityDepartureWrapper = createRef();
    this.multicityReturnWrapper = createRef();
    this.multicityClassWrapper = createRef();
    this.departureListWrapper = createRef();
    this.returnListWrapper = createRef();
    this.setDropdownWrapperRef = createRef();
    this.box = createRef(null);
    this.state = {
      showMulticitySrp: false,
      departureAirPortName: "",
      goingToAirPortName: "",
      isOnewaySearch: true,
      departureValue: "",
      goingToValue: "",
      expandDepartureBoolean: false,
      expandGoingToBoolean: false,
      departureDateValue: format(new Date(), "dd-LLL-yyyy"),
      goingToDateValue: format(addDays(new Date(), 7), "dd-LLL-yyyy"),
      expandDepartureDateBoolean: false,
      expandGoingToDateBoolean: false,
      paxAdultValue: 1,
      paxChildrenValue: 0,
      paxInfantValue: 0,
      SelectedClassValue: { label: "Economy", id: 1 },
      openCabinClassList: false,
      getDepartureSuggestionList: [],
      getGoingToSuggestionList: [],
      getDepartureAirportCode: "",
      getGoingToAirportCode: "",
      openCabinClassListOne: false,
      isError: {
        departure: false,
        goingTo: false,
        departureDate: false,
        goingToDate: false,
      },
      returnCity: "",
      departureCity: "",
      isMultiCitySearch: false,
      openPaxList: false,
      guest_id: "",
      travellerCabinClass: { label: "Economy", id: 1 },
      FlightData: [
        {
          flight: 1,
          src: "",
          srcValue: "",
          dest: "",
          destValue: "",
          showsrcDropdown: false,
          showdestDropdown: false,
          departureDate: format(new Date(), "dd-LLL-yyyy"),
          returnDate: format(addDays(new Date(), 7), "dd-LLL-yyyy"),
          showdepartureDateDropdown: false,
          showreturnDateDropdown: false,
          advancesearch: {
            airlines: [],
            fcs: JSON.parse(JSON.stringify(rbdClass)),
            dtym: JSON.parse(JSON.stringify(DepartureTime)),
            cabinclass: { label: "Economy", id: 1 },
            showCabinClassList: false,
          },
          flexiBaggage: true,
          error: {
            destErrMsg: "",
            srcErrMsg: "",
            rbdCabinErrMsg: "",
          },
          bagreq: true,
          odt: cf.getDateWithFormat(new Date(), this?.props?.dateFormat),
          disabledDate: cf.getDateWithFormat(
            new Date(),
            this?.props?.dateFormat
          ),
          srcObjRecent: {},
          destObjRecent: {},
        },
      ],
      FareTypeOption: "",
      travellerCabin: false,
      selectedTripType: "oneWay",
      showTraveller: false,
      pax: {
        adults: 1,
        child: 0,
        infants: 0,
      },
      isAdvanceSearch: false,
      nonStopflag: "",
      tripTypeArr: [...TripType],
      commomErrorMsg: "",
      toRecent: [],
      fromRecent: [],
    };

    this.box = createRef(null);
  }
  componentDidMount() {
    console.log("isSRP", this.props.isSRP, this.props.multicityFlag);
    console.log("multicityFlag", this.props.multicityFlag);

    let FlightDataCopy = JSON.parse(JSON.stringify(this.state.FlightData));

    if (this.props?.userProfile?.accessToken) {
      this.getRecentSearchFlightlWidgetApp("from").then((recent) => {
        let from_recent = recent?.data?.recentSearch || [];

        this.setState({
          fromRecent: from_recent,
        });
      });

      this.getRecentSearchFlightlWidgetApp("to").then((recent) => {
        let to_recent = recent?.data?.recentSearch || [];
        this.setState({
          toRecent: to_recent,
        });
      });
    } else {
      this.setState({
        fromRecent: localStorage.getItem("from_recent_serachFlight")
          ? JSON.parse(localStorage.getItem("from_recent_serachFlight"))
          : [],
        toRecent: localStorage.getItem("to_recent_serachFlight")
          ? JSON.parse(localStorage.getItem("to_recent_serachFlight"))
          : [],
      });
    }

    if (!this.props.multicityFlag) {
      this.setState({
        tripTypeArr: TripType.filter((ele, id) => ele.value !== "Multicity"),
      });
    }

    if (this.props.isSRP) {
      this.setState({ nonStopflag: this.props.nonStopflag });

      if (this.props.FlightData && this.props.FlightData.length) {
        this.props.FlightData.forEach((flightObj, id) => {
          console.log(
            "🚀 ~ file: index.js:168 ~ Theme1 ~ this.props.FlightData.forEach ~ flightObj:",
            flightObj
          );

          flightObj.srcObjRecent = {};
          flightObj.destObjRecent = {};

          if (this.props.tripType !== "1" && id !== 0) {
            flightObj.disabledDate =
              this.props.FlightData[id - 1].departureDate;
            console.log("flightObj.disabledDate", flightObj.disabledDate);
          }
          // rbd Class
          let rbdClass1 = JSON.parse(JSON.stringify(rbdClass));
          if (flightObj.advancesearch?.fcs?.length) {
            let tempOptions = flightObj.advancesearch.fcs;
            let temprdbOptions = JSON.parse(JSON.stringify(rbdClass));
            for (let i = 0; i < temprdbOptions.length; i++) {
              if (tempOptions.includes(temprdbOptions[i].value)) {
                temprdbOptions[i].isChecked = true;
              }
            }
            rbdClass1 = temprdbOptions;
          }
          flightObj.advancesearch.fcs = rbdClass1;
          // rbd Class

          // dtym Class
          let departureTime = JSON.parse(JSON.stringify(DepartureTime));
          if (flightObj.advancesearch.dtym.length) {
            let tempOptions = flightObj.advancesearch.dtym;
            console.log("tempOptionsfgh", tempOptions);

            let temprdbOptions = JSON.parse(JSON.stringify(DepartureTime));
            if (!tempOptions[0]) {
              tempOptions[0] = "All";
            }
            for (let i = 0; i < temprdbOptions.length; i++) {
              //  console.log("tempOptions.includes(temprdbOptions[i].value",tempOptions.includes(temprdbOptions[i].code))
              if (tempOptions.includes(temprdbOptions[i].code)) {
                temprdbOptions[i].isChecked = true;
              } else {
                temprdbOptions[i].isChecked = false;
              }
            }

            departureTime = temprdbOptions;
          }
          flightObj.advancesearch.dtym = departureTime;
          // dtym Class
          let tempCambin =
            flightObj.advancesearch.cabinclass &&
            typeof flightObj.advancesearch.cabinclass == "string"
              ? cabinClass.find(
                  (ele) => ele.id == flightObj?.advancesearch?.cabinclass
                )
              : flightObj.advancesearch.cabinclass;

          // cabin Class
          // flightObj.advancesearch.cabinclass = cabinClass.find((ele) => ele.id == flightObj.advancesearch.cabinclass ) || { label: "Economy", id: 1 }
          if (
            flightObj.advancesearch.cabinclass &&
            typeof flightObj.advancesearch.cabinclass == "string"
          ) {
            flightObj.advancesearch.cabinclass = JSON.parse(
              JSON.stringify(tempCambin)
            ) || { label: "Economy", id: 1 };
          }
          // cabin Class
          if (id == 0 && flightObj.advancesearch.cabinclass) {
            console.log("tempCambin", tempCambin);
            this.setState(
              {
                travellerCabinClass: JSON.parse(JSON.stringify(tempCambin)) || {
                  label: "Economy",
                  id: 1,
                },
              },
              () => {
                console.log(
                  "🚀 ~ file: index.js:221 ~ Theme1 ~ this.props.FlightData.forEach ~ travellerCabinClass:",
                  this.state.travellerCabinClass,
                  flightObj?.advancesearch?.cabinclass
                );
              }
            );
          }

          // if (id == 0) {
          //   this.setState({
          //     travellerCabinClass: cabinClass.find((ele) => ele.id == parseInt(flightObj.advancesearch.cabinclass.id)) || { label: "Economy", id: 1 },
          //   },()=>{
          //     console.log("🚀 ~ file: index.js:221 ~ Theme1 ~ this.props.FlightData.forEach ~ travellerCabinClass:", this.state.travellerCabinClass ,flightObj?.advancesearch?.cabinclass)

          //   })
          // }
        });

        FlightDataCopy = JSON.parse(JSON.stringify(this.props.FlightData));
        console.log("🚀 ~ FlightDataCopy1:", FlightDataCopy);
      }
      console.log("this.props.pax1", this.props.pax);

      let trip = this.state.tripTypeArr.find(
        (ele) => ele.id == this.props.tripType
      );
      console.log("this.props.pax", trip);

      this.setState(
        {
          selectedTripType: trip?.value,
          isAdvanceSearch: this.props.isAdvanceSearch,
          pax: this.props.pax,
          guest_id: this.props.guest_id || "",
        },
        () => {
          console.log(
            "testt",
            +this.state.pax.adults +
              +this.state.pax.child +
              +this.state.pax.infants
          );
        }
      );
    }

    this.setState({
      FlightData: FlightDataCopy,
    });

    getSupplierList().then((res) => {
      console.log("getAirlines===>res===>", res);
      if (res.data && res.data.airlines && res.data.airlines.length > 0) {
        airline = res.data.airlines.map((ele, id) => {
          return {
            label: ele.name,
            value: ele.code,
            isChecked: false,
            displayValue: ele,
          };
        });
        airline.unshift({
          label: "All",
          value: "*",
          isChecked: false,
          displayValue: "All",
        });

        FlightDataCopy.forEach((element) => {
          let tempOptions = element.advancesearch.airlines;
          let temprdbOptions = JSON.parse(JSON.stringify(airline));
          for (let i = 0; i < temprdbOptions.length; i++) {
            if (tempOptions.includes(temprdbOptions[i].value))
              temprdbOptions[i].isChecked = true;
          }
          airline = temprdbOptions;
          element.advancesearch.airlines = JSON.parse(JSON.stringify(airline));
        });
        console.log("🚀 ~ FlightDataCopy:", FlightDataCopy);

        this.setState({
          FlightData: FlightDataCopy,
        });
      }
    });
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  async getRecentSearchFlightlWidgetApp(type) {
    let req = { type };

    let recent_response = await getRecentSearchFlightlWidget(req);
    console.log(
      "🚀 ~ Theme1 ~ getRecentSearchFlightlWidgetApp ~ recent_response:",
      recent_response
    );
    return recent_response;
  }

  componentWillReceiveProps(nextProps) {
    console.log(
      "🚀 ~ file: index.js:288 ~ Theme1 ~ componentWillReceiveProps ~ nextProps:",
      nextProps
    );
  }
  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  flexiBaggageHandler(index) {
    const FlightDataCopy = JSON.parse(JSON.stringify(this.state.FlightData));
    FlightDataCopy[index][`flexiBaggage`] =
      !FlightDataCopy[index][`flexiBaggage`];
    this.setState({ FlightData: FlightDataCopy });
  }

  // Autocomplete functions
  onclickFlightAutoComplete(type, i) {
    const FlightDataCopy = JSON.parse(JSON.stringify(this.state.FlightData));
    FlightDataCopy[i][`${type}`] = "";
    FlightDataCopy[i][`${type}Value`] = "";

    this.setState({ FlightData: FlightDataCopy });
    console.log("🚀 3", FlightDataCopy);

    this.props.getAutoSuggestData(
      FlightDataCopy[i][`${type}`],
      type == "src" ? "departure" : "return",
      "click"
    );

    if (type == "src") {
      FlightDataCopy[i][`showdestDropdown`] = false;
    }
    if (type == "dest") {
      FlightDataCopy[i][`showsrcDropdown`] = false;
    }

    FlightDataCopy[i][`show${type}Dropdown`] = true;
    this.setState({ FlightData: FlightDataCopy });
  }

  expandAutoComplete = (bool, type, index) => {
    const FlightDataCopy = JSON.parse(JSON.stringify(this.state.FlightData));
    FlightDataCopy[index][`show${type}Dropdown`] = bool;
    console.log("🚀 2", FlightDataCopy);

    this.setState({ FlightData: FlightDataCopy });
  };

  autoCompleteLeftIcon = () => {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="26" height="17">
        <path
          fill-rule="evenodd"
          fill="#01445F"
          d="M23.819 6.123 8.442 12.885a1.015 1.015 0 0 1-.331.07.93.93 0 0 1-.474-.152L.924 8.43c-.126-.475-.225-.595-.285-.736-.179-.415.013-.897 1.031-1.076l1.294-.819a.82.82 0 0 1 .682 0L8.414 8.96l4.689-2.67-6.46-3.581a.817.817 0 0 1-.376-.398c.583-.413.004-.897.417-1.08l2.253-.99a.79.79 0 0 1 .589-.029L19.64 3.401l2.327-1.282a2.296 2.296 0 0 1 1.807 0c1.75.676 1.754 3.292.045 4.004zm-.695-2.505a.67.67 0 0 0-.52 0L19.456 5.5c-.191.42.024-.393-.609-.04L9.305 1.857l-.389.443 6.456 3.053a.82.82 0 0 1 .221 1.294.996.996 0 0 1-.266.184L8.72 9.746a.866.866 0 0 1-.266.061c-.14.011-.281-.014.006-.074L3.278 7.441l.052.098 4.875 3.66 14.919-6.587a.54.54 0 0 0 .265-.266c.128.374.009-.601-.265-.728zM1.398 15.35h22.895a.818.818 0 0 1 0 1.637H1.398a.819.819 0 0 1 0-1.637z"
        ></path>
      </svg>
    );
  };

  onClickSetDepartureGoingToValue = (
    city,
    airPortCode,
    airPortName,
    type,
    index,
    valueObj
  ) => {
    console.log(
      "🚀 ~ file: index.js:369 ~ Theme1 ~ type:",
      this.state.FlightData,
      city,
      airPortCode,
      airPortName,
      type,
      index,
      valueObj
    );

    let FlightDataCopy = JSON.parse(JSON.stringify(this.state.FlightData));
    FlightDataCopy[index]["error"][`${type}ErrMsg`] = "";
    if (this.state.selectedTripType == "roundTrip") {
      let copyIndex = index == 0 ? 1 : 0;
      let copyType = type == "src" ? "dest" : "src";
      FlightDataCopy[copyIndex][`${copyType}Value`] = city;
      FlightDataCopy[copyIndex][`${copyType}`] = airPortCode;
      FlightDataCopy[copyIndex][`${copyType}ObjRecent`] = valueObj;
    }
    FlightDataCopy[index][`${type}Value`] = city;
    FlightDataCopy[index][`${type}`] = airPortCode;
    FlightDataCopy[index][`${type}ObjRecent`] = valueObj;

    FlightDataCopy[index][`show${type}Dropdown`] = false;
    console.log("1aarti", FlightDataCopy);

    if (
      this.state.selectedTripType == "Multicity" &&
      type == "dest" &&
      index < FlightDataCopy.length - 1
    ) {
      FlightDataCopy[index + 1]["error"][`srcErrMsg`] = "";

      FlightDataCopy[index + 1][`srcValue`] = city;
      FlightDataCopy[index + 1][`src`] = airPortCode;
      FlightDataCopy[index + 1][`srcObjRecent`] = valueObj;

      console.log("🚀 ~ Theme1 ~ FlightDataCopy:", FlightDataCopy);
    }
    let error = "";

    if (this.props?.isMobile) {
      error = FlightDataCopy.some((el) => {
        return (
          el.error.destErrMsg || el.error.srcErrMsg || el.error.rbdCabinErrMsg
        );
      })
        ? "Please enter required details"
        : "";
    }

    this.setState({ FlightData: FlightDataCopy, commomErrorMsg: error }, () => {
      console.log(
        "🚀 ~ file: index.js:140 ~ FlightData[index]:",
        this.state.FlightData
      );
      // this.checkValidation(this.state);
    });
  };

  onChangeSetDepartureGoingToValue = (value, type, index) => {
    console.log(
      "🚀 ~ file: index.js:392 ~ Theme1 ~ value, type, index:",
      value,
      type,
      index
    );

    let FlightDataCopy = JSON.parse(JSON.stringify(this.state.FlightData));
    FlightDataCopy[index][`${type}`] = value;
    FlightDataCopy[index]["error"][`${type}ErrMsg`] = "";

    this.setState({ FlightData: FlightDataCopy }, () => {
      let FlightDataCopy1 = JSON.parse(JSON.stringify(this.state.FlightData));
      if (value.length > 2) {
        this.props.getAutoSuggestData(
          value,
          type == "src" ? "departure" : "return",
          value ? "change" : "click"
        );
      }
      FlightDataCopy1[index][`show${type}Dropdown`] = true;
      console.log("🚀 4", FlightDataCopy1);
      this.setState({ FlightData: FlightDataCopy1 });
    });
  };
  // Autocomplete functions
  // calendar functions
  onChangeDepartureGoingDateValue = (value, type, index) => {
    const FlightDataCopy = JSON.parse(JSON.stringify(this.state.FlightData));
    console.log(
      "🚀 ~ file: index.js:489 ~ Theme1 ~ FlightDataCopy:",
      FlightDataCopy
    );

    FlightDataCopy[index][`${type}Date`] = cf.getDateWithFormat(
      value,
      this?.props?.dateFormat
    );
    if (type == "return") {
      let dayDifference = differenceInCalendarDays(
        new Date(FlightDataCopy[index][`returnDate`]),
        new Date(value)
      );
      if (dayDifference < 0)
        FlightDataCopy[index][`returnDate`] = cf.getDateWithFormat(
          addDays(new Date(value), 7),
          this?.props?.dateFormat
        );
    }
    FlightDataCopy[index][`show${type}DateDropdown`] = false;
    let dayDifference = differenceInCalendarDays(
      new Date(FlightDataCopy[0][`returnDate`]),
      new Date(value)
    );

    if (
      type == "departure" &&
      dayDifference < 0 &&
      this.state.selectedTripType == "oneWay"
    ) {
      FlightDataCopy[0][`returnDate`] = cf.getDateWithFormat(
        addDays(new Date(value), 7),
        this?.props?.dateFormat
      );
    }
    if (this.state.selectedTripType == "roundTrip") {
      if (index == 1 && type == "departure")
        FlightDataCopy[0][`returnDate`] = cf.getDateWithFormat(
          value,
          this?.props?.dateFormat
        );
      console.log("FlightDataCopy:", FlightDataCopy[1]);
      FlightDataCopy[1][`disabledDate`] = cf.getDateWithFormat(
        new Date(value),
        this?.props?.dateFormat
      );

      let dayDifference = differenceInCalendarDays(
        new Date(FlightDataCopy[0][`returnDate`]),
        new Date(value)
      );
      if (index == 0 && type == "departure" && dayDifference < 0) {
        FlightDataCopy[0][`returnDate`] = cf.getDateWithFormat(
          addDays(new Date(value), 7),
          this?.props?.dateFormat
        );
        FlightDataCopy[1][`departureDate`] = cf.getDateWithFormat(
          addDays(new Date(value), 7),
          this?.props?.dateFormat
        );
      }

      if (index == 0 && type == "return")
        FlightDataCopy[1][`departureDate`] = cf.getDateWithFormat(
          value,
          this?.props?.dateFormat
        );
    }

    if (this.state.selectedTripType == "Multicity") {
      for (let i = index + 1; i < FlightDataCopy.length; i++) {
        let dayDifference = differenceInCalendarDays(
          new Date(FlightDataCopy[i][`departureDate`]),
          new Date(value)
        );
        if (dayDifference < 0)
          FlightDataCopy[i][`departureDate`] = cf.getDateWithFormat(
            addDays(new Date(value), 7),
            this?.props?.dateFormat
          );
        FlightDataCopy[i]["disabledDate"] = cf.getDateWithFormat(
          FlightDataCopy[i - 1][`departureDate`],
          this?.props?.dateFormat
        );
      }
    }
    this.setState({ FlightData: FlightDataCopy });
  };

  calendarSvgIcon = () => {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="26" height="17">
        <path
          fill-rule="evenodd"
          fill="#01445F"
          d="M23.819 6.123 8.442 12.885a1.015 1.015 0 0 1-.331.07.93.93 0 0 1-.474-.152L.924 8.43c-.126-.475-.225-.595-.285-.736-.179-.415.013-.897 1.031-1.076l1.294-.819a.82.82 0 0 1 .682 0L8.414 8.96l4.689-2.67-6.46-3.581a.817.817 0 0 1-.376-.398c.583-.413.004-.897.417-1.08l2.253-.99a.79.79 0 0 1 .589-.029L19.64 3.401l2.327-1.282a2.296 2.296 0 0 1 1.807 0c1.75.676 1.754 3.292.045 4.004zm-.695-2.505a.67.67 0 0 0-.52 0L19.456 5.5c-.191.42.024-.393-.609-.04L9.305 1.857l-.389.443 6.456 3.053a.82.82 0 0 1 .221 1.294.996.996 0 0 1-.266.184L8.72 9.746a.866.866 0 0 1-.266.061c-.14.011-.281-.014.006-.074L3.278 7.441l.052.098 4.875 3.66 14.919-6.587a.54.54 0 0 0 .265-.266c.128.374.009-.601-.265-.728zM1.398 15.35h22.895a.818.818 0 0 1 0 1.637H1.398a.819.819 0 0 1 0-1.637z"
        ></path>
      </svg>
    );
  };

  onchangeVisibility = (bool, type, index) => {
    console.log("🚀 ~ Theme1 ~ onchangeVisibility:", type);

    const FlightDataCopy = JSON.parse(JSON.stringify(this.state.FlightData));
    FlightDataCopy[index][`show${type}DateDropdown`] = bool;
    FlightDataCopy[index][`showdestDropdown`] = false;

    this.setState({ FlightData: FlightDataCopy });

    console.log("FlightDataCopy22", FlightDataCopy, bool, type, index);
  };
  onClickReturn(type, index) {
    console.log(
      "🚀 ~ file: index.js:481 ~ Theme1 ~ onClickReturn ~  type, index:",
      type,
      index,
      this.state.selectedTripType
    );
    const FlightDataCopy = JSON.parse(JSON.stringify(this.state.FlightData));
    FlightDataCopy[index][`show${type}DateDropdown`] = false;
    this.setState({ FlightData: FlightDataCopy }, () => {
      if (type == "departure" && this.state.selectedTripType == "oneWay") {
        this.onselectTrip({ id: 2, value: "roundTrip", label: "Round Trip" });
        let FlightDataCopy1 = JSON.parse(JSON.stringify(FlightDataCopy));
        FlightDataCopy1[index][`showreturnDateDropdown`] = true;
        console.log(
          "🚀 ~ file: index.js:485 ~ Theme1 ~ onClickReturn ~ FlightDataCopy:",
          FlightDataCopy1
        );

        this.setState({ FlightData: FlightDataCopy1 });
      } else {
        this.onselectTrip({ id: 1, value: "oneWay", label: "One Way" });
        let FlightDataCopy1 = JSON.parse(JSON.stringify(FlightDataCopy));
        FlightDataCopy1[index][`showdepartureDateDropdown`] = true;
        console.log(
          "🚀 ~ file: index.js:485 ~ Theme1 ~ onClickReturbn ~ FlightDataCopy:",
          FlightDataCopy1
        );

        this.setState({ FlightData: FlightDataCopy1 });
      }
    });
  }
  crossIcon() {
    return (
      <svg
        version="1.1"
        id="Layer_1"
        x="0px"
        y="0px"
        width="50px"
        height="50px"
        viewBox="0 0 50 50"
        enable-background="new 0 0 50 50"
      >
        <g>
          <path
            fill="#ececec"
            d="M24.972,2.696c-12.322,0-22.337,9.995-22.337,22.303c0,12.302,10.015,22.306,22.337,22.306
       c12.326,0,22.336-10.004,22.336-22.306C47.309,12.69,37.298,2.696,24.972,2.696z M24.972,45.273
       c-11.224,0-20.306-9.07-20.306-20.275c0-11.21,9.082-20.275,20.306-20.275c11.228,0,20.307,9.065,20.307,20.275
       C45.279,36.205,36.2,45.273,24.972,45.273z M33.333,16.685c-0.201-0.207-0.482-0.321-0.771-0.308
       c-0.265,0.002-0.516,0.111-0.698,0.299l-6.885,6.875l-6.901-6.875c-0.192-0.193-0.455-0.302-0.729-0.299
       c-0.039-0.003-0.075-0.003-0.112,0c-0.559,0.054-0.966,0.55-0.913,1.106c0.025,0.243,0.134,0.469,0.311,0.635l6.884,6.891
       l-6.884,6.875c-0.399,0.396-0.399,1.043,0,1.441c0.397,0.396,1.045,0.396,1.442,0l6.901-6.891l6.885,6.891
       c0.398,0.396,1.044,0.396,1.441,0c0.401-0.398,0.401-1.045,0-1.441l-6.898-6.875l6.898-6.891
       C33.709,17.729,33.723,17.088,33.333,16.685z"
          />
        </g>
      </svg>
    );
  }

  withMobileDiv() {
    this.props?.isMobile ? <div></div> : null;
  }

  // calendar functions

  onChangeCabinClassValue = (element, index) => {
    let FlightDataCopy = JSON.parse(JSON.stringify(this.state.FlightData));
    // FlightDataCopy[index]["advancesearch"]["cabinclass"] = element
    // FlightDataCopy[index]["advancesearch"]["fcs"] = JSON.parse(JSON.stringify(rbdClass))
    // FlightDataCopy[index]["advancesearch"]["showCabinClassList"] = false
    console.log(
      "🚀 ~ file: index.js:399 ~ Theme1 ~ FlightDataCopy: 1",
      FlightDataCopy
    );

    FlightDataCopy = FlightDataCopy.map((el, id) => {
      return {
        ...el,
        advancesearch: {
          ...el?.advancesearch,
          fcs: JSON.parse(JSON.stringify(rbdClass)),
          cabinclass:
            index == id
              ? element
              : el.advancesearch.cabinclass == {}
              ? { label: "Economy", id: 1 }
              : el.advancesearch.cabinclass,
          showCabinClassList:
            index == id ? false : el.advancesearch.showCabinClassList,
        },
      };
    });

    this.setState({ FlightData: FlightDataCopy }, () => {
      console.log("this.state.FlightData", this.state.FlightData);
    });
  };

  onClickCabinClass = (index) => {
    console.log("hereee");
    const FlightDataCopy = JSON.parse(JSON.stringify(this.state.FlightData));
    FlightDataCopy[index]["advancesearch"]["showCabinClassList"] =
      !FlightDataCopy[index]["advancesearch"]["showCabinClassList"];
    console.log(
      "🚀 ~ file: index.js:284 ~ Theme1 ~ FlightDataCopy[index]",
      FlightDataCopy[index]["showCabinClassList"]
    );
    this.setState({ FlightData: FlightDataCopy });
  };

  onReturnClick(type) {
    if (type == "departure") {
      selectedTripType == "RoundTrip";
    }
  }

  onClickChangePaxNumber = (pax, value, type) => {
    let paxCopy = JSON.parse(JSON.stringify(this.state.pax));
    if (pax === "adults") {
      if (
        +this.state.pax.child + value <= 9 &&
        +this.state.pax.child + value > 0
      ) {
        paxCopy.adults = value;
        if (type === "minus") {
          if (+this.state.pax.infants > value) {
            paxCopy.infants = +paxCopy.infants;
            --paxCopy.infants;
          }
        }
      }
    } else if (pax === "child") {
      if (
        +value + +this.state.pax.adults <= 9 &&
        +value + +this.state.pax.adults > 0
      )
        paxCopy.child = +value;
    } else if (pax === "infants") {
      if (value > +this.state.pax.adults) paxCopy.infants = +--value;
      else paxCopy.infants = +value;
    }

    console.log("paxCopy", paxCopy);
    this.setState({ pax: paxCopy }, () => {
      console.log("aarti 3", this.state.pax);
    });
  };

  removeList(id) {
    const FlightDataCopy = JSON.parse(JSON.stringify(this.state.FlightData));
    FlightDataCopy.splice(id, 1);
    this.setState({ FlightData: FlightDataCopy }, () => {
      console.log("removeList", this.state.FlightData);
    });
  }

  AddFlightButton = () => {
    const FlightDataCopy = JSON.parse(JSON.stringify(this.state.FlightData));

    let multiObj = {};

    if (FlightDataCopy[FlightDataCopy.length - 1].flight) {
      let previousFlight = FlightDataCopy[FlightDataCopy.length - 1];
      console.log(
        "🚀  file: index.js:353  Theme1 ~ previousFlight:",
        addDays(new Date(previousFlight?.departureDate), 1),
        this.props.dateFormat
      );
      if (FlightDataCopy.length <= 5) {
        multiObj = {
          ...multiObj,
          flight: previousFlight.flight + 1,
          src: previousFlight.dest,
          srcValue: previousFlight.destValue,
          dest: "",
          destValue: "",
          showsrcDropdown: false,
          showdestDropdown: false,
          departureDate: previousFlight.departureDate
            ? format(
                addDays(new Date(previousFlight?.departureDate), 1),
                "dd-MMM-yyyy"
              )
            : "",
          returnDate: previousFlight.returnDate
            ? format(
                addDays(new Date(previousFlight?.returnDate), 7),
                "dd-MMM-yyyy"
              )
            : "",
          showdepartureDateDropdown: false,
          showreturnDateDropdown: false,
          advancesearch: {
            airlines: JSON.parse(JSON.stringify(airline)),
            fcs: JSON.parse(JSON.stringify(rbdClass)),
            dtym: JSON.parse(JSON.stringify(DepartureTime)),
            cabinclass: { label: "Economy", id: 1 },
            showCabinClassList: false,
          },
          flexiBaggage: true,
          bagreq: true,
          odt: previousFlight.departureDate
            ? format(new Date(previousFlight?.departureDate), "dd-MMM-yyyy")
            : format(Date.now(), this?.props?.dateFormat),
          disabledDate: previousFlight.departureDate
            ? format(new Date(previousFlight?.departureDate), "dd-MMM-yyyy")
            : format(Date.now(), this?.props?.dateFormat),
          error: {
            destErrMsg: "",
            srcErrMsg: "",
          },
        };
        FlightDataCopy.push(multiObj);
      }
    } else {
      multiObj = {
        ...multiObj,
        flight: 1,
        src: "",
        srcValue: org ? org : "",
        dest: "",
        destValue: "",
        showsrcDropdown: false,
        showdestDropdown: false,
        departureDate: format(new Date(), this?.props?.dateFormat),
        returnDate: format(addDays(new Date(), 7), this?.props?.dateFormat),
        showdepartureDateDropdown: false,
        showreturnDateDropdown: false,
        advancesearch: {
          airlines: JSON.parse(JSON.stringify(airline)),
          fcs: JSON.parse(JSON.stringify(rbdClass)),
          dtym: JSON.parse(JSON.stringify(DepartureTime)),
          cabinclass: { label: "Economy", id: 1 },
          showCabinClassList: false,
        },
        flexiBaggage: true,
        bagreq: true,
        odt: cf.getDateWithFormat(new Date(), this?.props?.dateFormat),
        disabledDate: cf.getDateWithFormat(new Date(), this?.props?.dateFormat),
        error: {
          destErrMsg: "",
          srcErrMsg: "",
        },
      };
      FlightDataCopy.push(multiObj);
    }

    console.log(
      "🚀  file: index.js:540  Theme1  this.setState  FlightDataCopy13:",
      FlightDataCopy
    );

    this.setState({ FlightData: FlightDataCopy }, () => {
      console.log(
        "🚀  file: index.js:534  Theme1  this.setState  FlightData:",
        this.state.FlightData
      );
    });
  };

  //Add client
  adGuestId = (id) => {
    this.setState({ guest_id: id }, () => {
      if (this.state.isError.selectedGuest === true) {
        this.validateErrorMsg();
      }
      this.setState({ guest_id: id });
    });
  };

  rmGuestId = () => {
    this.setState({ guest_id: "" });
  };

  showmulticity = () => {
    console.log("this.state.showMulticitySrp", this.state?.showMulticitySrp);

    this.setState({
      showMulticitySrp: !this.state.showMulticitySrp,
    });
  };

  popupClosed(id, type) {
    console.log(
      "🚀 ~ file: index.js:667 ~ Theme1 ~ popupClosed ~ popupClosed:",
      id,
      type
    );

    const FlightDataCopy = JSON.parse(JSON.stringify(this.state.FlightData));
    FlightDataCopy[id][`show${type}Dropdown`] = false;

    this.setState({ FlightData: FlightDataCopy });
  }
  closedTravellerPopup(type) {
    if (type === "cabinTraveller") {
      this.setState({ travellerCabin: false }, () => {
        document.querySelector("body").style.overflow = "auto";
      });
    }
  }
  handleClickOutside = () => {
    const FlightDataCopy = JSON.parse(JSON.stringify(this.state.FlightData));

    if (this.state.openCabinClassList === true)
      this.setState({ openCabinClassList: false });
    if (this.state.expandDepartureBoolean === true)
      this.setState({ expandDepartureBoolean: false });
    if (this.state.expandGoingToBoolean === true)
      this.setState({ expandGoingToBoolean: false });
    if (
      this.guestDetailWrapper.current &&
      !this.guestDetailWrapper.current.contains(event.target)
    ) {
      this.setState({ openTraveler: false });
    }
    if (
      this.passengerDropdownWrapper.current &&
      !this.passengerDropdownWrapper.current.contains(event.target)
    ) {
      this.setState({ showTraveller: false });
    }

    if (
      this.travellerCabin.current &&
      !this.travellerCabin.current.contains(event.target)
    ) {
      this.setState({ travellerCabin: false }, () => {
        document.querySelector("body").style.overflow = "auto";
      });
    }

    if (
      this.departureListWrapper.current &&
      !this.departureListWrapper.current.contains(event.target)
    ) {
      let index = this.departureListWrapper.current.id
        ? this.departureListWrapper.current.id.split("_")[2]
        : "";

      FlightDataCopy[index]["showsrcDropdown"] = false;
    }

    if (
      this.returnListWrapper.current &&
      !this.returnListWrapper.current.contains(event.target)
    ) {
      let index = this.returnListWrapper.current.id
        ? this.returnListWrapper.current.id.split("_")[2]
        : "";

      FlightDataCopy[index]["showdestDropdown"] = false;
    }

    if (
      this.economyPopUpWrapper.current &&
      this.economyPopUpWrapper.current.length
    ) {
      this.economyPopUpWrapper.current.forEach((wrapper) => {
        if (!wrapper?.contains(event.target)) {
          let index = wrapper?.id ? parseInt(wrapper.id.split("_")[2]) : 0;
          FlightDataCopy[index]["advancesearch"]["showCabinClassList"] = false;
        }
      });
    }
    this.setState({ FlightData: FlightDataCopy });
  };
  onClickOpenCabinClassList = () => {
    // document.getElementById("modal_container-popup").scrollIntoView({ behavior: 'smooth', block: 'start' })
    if (this.state.openCabinClassList === false) {
      this.setState({ openCabinClassList: true });
    } else if (this.state.openCabinClassList === true) {
      this.setState({ openCabinClassList: false });
    }
  };

  checkValidation = (item) => {
    let isValid = true;
    const { FlightData = [] } = item;
    FlightData.forEach((data, index) => {
      console.log(
        "🚀 ~ file: index.js:456 ~ Theme1 ~ FlightData.forEach ~ data:",
        data
      );
      let errorObj = data.error || {};

      if (data["srcValue"] === data["destValue"] && data["destValue"] !== "") {
        isValid = false;
        errorObj["destErrMsg"] = "Origin and destination cannot be same";
      }
      if (
        this.state.selectedTripType == "roundTrip"
        // ||
        // this.state.selectedTripType == "Multicity"
      ) {
        if (
          index !== FlightData.length - 1 &&
          data["srcValue"] === FlightData[index + 1]["srcValue"] &&
          data["destValue"] === FlightData[index + 1]["destValue"]
        ) {
          isValid = false;
          errorObj["destErrMsg"] = "Origin and destination cannot be same";
          FlightData[index + 1].error.destErrMsg =
            "Origin and destination cannot be same";
        }
      }

      if (data["srcValue"] === "") {
        isValid = false;
        errorObj["srcErrMsg"] = "Enter Origin City";
      }
      if (data["destValue"] === "") {
        isValid = false;
        errorObj["destErrMsg"] = "Enter Destination City";
      }

      // if (!data["advancesearch"]["fcs"].some((el) => el?.isChecked) && Object?.keys(data["advancesearch"]["cabinclass"]).length === 0) {
      //   isValid = false
      //   errorObj['rbdCabinErrMsg'] = 'Please Select RBD/ Cabin'
      // }
      data.error = errorObj;
    });

    console.log("FlightData1234", FlightData);
    return { isValid, data: FlightData };
  };

  getSector = (data) => {
    let resp = data.map((element) => {
      console.log("datee aarti", element);
      let srcValue = element?.srcValue.split("-");
      console.log("srghgcValue", srcValue, srcValue[0].trim());

      let destValue = element?.destValue.split("-");
      if (element.advancesearch.dtym == "All") {
        element.advancesearch.dtym = "";
      }

      return {
        from: element?.src,
        to: element?.dest,
        fromcity: srcValue[0].trim(),
        tocity: destValue[0].trim(),
        date: format(new Date(element?.departureDate), "yyyy-MM-dd"),
        cabin: element.advancesearch?.cabinclass
          ? `${element.advancesearch?.cabinclass}`
          : 0,
        rbd: element.advancesearch?.fcs,
        airlines: element.advancesearch?.airlines,
        departuretime: element.advancesearch.dtym,
        flexibag: element.advancesearch.bagreq === true ? "1" : "0",
      };
    });
    console.log("gdataaaa", resp);

    return resp;
  };

  onClickSearchFlight = () => {
    let { isValid, data } = this.checkValidation(this.state);

    let recentSearch = {
      from: {},
      to: {},
    };

    console.log(
      "🚀 ~ file: index.js:550 ~ Theme1 ~ isValid:",
      isValid,
      this.state.FlightData,
      data
    );

    if (this.state.travellerCabin == true) {
      this.setState({
        travellerCabin: false,
      });
    }

    if (!isValid && this.props.isMobile) {
      this.setState({
        commomErrorMsg: "Please enter required details",
      });
    }

    if (isValid) {
      console.log("this.state.FlightData", this.state.FlightData);
      let updatedFlightData = this.state.FlightData.map((flightObj, id) => {
        console.log(
          "🚀 ~ file: index.js:623 ~ Theme1 ~ updatedFlightData ~ flightObj:",
          flightObj,
          this.state.travellerCabinClass?.id
        );

        if (id == 0) {
          recentSearch.from = flightObj.srcObjRecent;
        }
        if (id == this.state.FlightData.length - 1) {
          recentSearch.to = flightObj.destObjRecent;
        }

        // setState({

        // })

        return {
          ...flightObj,
          advancesearch: {
            airlines:
              flightObj.advancesearch.airlines &&
              flightObj.advancesearch.airlines
                .filter((option) => option.isChecked)
                .map((item) => item.value),
            fcs:
              flightObj.advancesearch.fcs &&
              flightObj.advancesearch.fcs
                .filter((option) => option.isChecked)
                .map((item) => item.value),
            dtym: flightObj.advancesearch.dtym
              .filter((option) => option.isChecked)
              .map((item) => item.code),
            cabinclass: this.state.isAdvanceSearch
              ? flightObj?.advancesearch?.cabinclass?.id
              : this.state.travellerCabinClass?.id,
          },
        };
      });

      console.log(
        "🚀 ~ Theme1 ~ SetRecentSearchFlightlWidget ~ recentSearch:",
        recentSearch
      );

      if (this.props?.userProfile?.accessToken) {
        SetRecentSearchFlightlWidget(recentSearch).then((res) => {
          console.log("🚀 ~ Theme1 ~ SetRecentSearchFlightlWidget ~ res:", res);
        });
      } else {
        let filteredRecentSearches = localStorage?.getItem(
          "from_recent_serachFlight"
        )
          ? JSON.parse(localStorage?.getItem("from_recent_serachFlight"))
          : [];
        console.log(
          "🚀 ~ Theme1 ~ from_recent_serachFlight:",
          filteredRecentSearches
        );

        filteredRecentSearches = [
          recentSearch?.from,
          ...filteredRecentSearches,
        ];

        let from_recent_serachFlight = filteredRecentSearches
          .filter(
            (search, index, self) =>
              index ===
              self.findIndex((s) => s?.AIRPORT_CODE === search.AIRPORT_CODE)
          )
          .slice(0, 5);

        console.log(
          "🚀 ~ Theme1 ~ from_recent_serachFlight:111",
          from_recent_serachFlight
        );

        // if(from_recent_serachFlight.length > 5){

        //   from_recent_serachFlight = from_recent_serachFlight.slice(0,4)

        //  }

        localStorage.setItem(
          "from_recent_serachFlight",
          JSON.stringify(from_recent_serachFlight)
        );

        let filteredRecentSearchesTo = localStorage?.getItem(
          "to_recent_serachFlight"
        )
          ? JSON.parse(localStorage?.getItem("to_recent_serachFlight"))
          : [];

        console.log(
          "🚀 ~ Theme1 ~ filteredRecentSearchesTo:",
          filteredRecentSearchesTo
        );

        filteredRecentSearchesTo = [
          recentSearch?.to,
          ...filteredRecentSearchesTo,
        ];

        let to_recent_serachFlight = filteredRecentSearchesTo
          .filter(
            (search, index, self) =>
              index ===
              self.findIndex((s) => s?.AIRPORT_CODE === search.AIRPORT_CODE)
          )
          .slice(0, 5);

        // if(to_recent_serachFlight.length > 5){

        //  to_recent_serachFlight = to_recent_serachFlight.slice(0,4)

        // }

        localStorage.setItem(
          "to_recent_serachFlight",
          JSON.stringify(to_recent_serachFlight)
        );

        this.setState({
          fromRecent: from_recent_serachFlight || [],
          toRecent: to_recent_serachFlight || [],
        });
      }

      console.log("updatedFlightData", updatedFlightData);
      let sectorRequest = this.getSector(updatedFlightData);
      console.log("gdataaaa", sectorRequest);

      let sector = getUrl(sectorRequest);
      let urseurl = parseurl(sector);

      console.log("temp", sector);

      console.log("urseurl", urseurl);
      let pax = Object.values(this.state.pax).map((value) => value);

      pax = pax.join("_");
      let supplier = this.props.selectedSupplier
        ? this.props.selectedSupplier
            .filter((option) => option.isChecked)
            .map((item) => item.value)
            .join("~")
        : [];
      let splfare = this.props.FareType
        ? this.props.FareType.filter((option) => option.isChecked).map(
            (item) => item.code
          )
        : "";
      console.log(
        "🚀 ~ file: index.js:836 ~ Theme1 ~ splfare:",
        splfare,
        this.props.FareType
      );

      let trip = TripType.find(
        (ele) => ele.value == this.state.selectedTripType
      );

      console.log("chgfjfgj", this.state?.guest_id);

      let urlQuery = {
        sector: sector,
        pax: pax,
        supplier: supplier,
        splfare: splfare,
        type: trip.id,
        isAdvanceSearch: this.state.isAdvanceSearch,
        guests: this.state?.guest_id,
        nonStop: this.state.nonStopflag,
        multicityFlag: this.props.multicityFlag,
      };
      console.log(
        "🚀 ~ file: index.js:581 ~ Theme1 ~ urlQuery:",
        urlQuery,
        this.props.isOffline
      );

      if (this.props.isSRP && this.props.isMobile) {
        this.props.modifySearchHandler();
      }

      if (!this.props.isOffline) {
        cf.redirectTo("flight/search", urlQuery);
      } else {
        cf.redirectTo("/offlinesearch/flight", urlQuery);
      }
    } else {
      this.setState({ FlightData: data }, () => {
        // console.log("dataaaaaaaaaaaa", this.state.FlightData);
      });
    }
  };

  validateErrorMsg = () => {
    const mapDispatch = {
      departure: commonFunction.isValueEmpty(this.state.departureValue)
        ? true
        : false,
      goingTo: commonFunction.isValueEmpty(this.state.goingToValue)
        ? true
        : false,
      departureDate: commonFunction.isValueEmpty(this.state.departureDateValue)
        ? true
        : false,
      goingToDate: commonFunction.isValueEmpty(this.state.goingToDateValue)
        ? true
        : false,
      selectedGuest: cf.isValueEmpty(this.state.guest_id) ? true : false,
    };
    this.setState({ isError: mapDispatch });
  };
  onClickSwap = (index) => {
    console.log(
      "🚀 ~ file: index.js:823 ~ Theme1 ~ index:",
      index,
      this.state.FlightData
    );
    const FlightDataCopy = JSON.parse(JSON.stringify(this.state.FlightData));
    const FlightDataCopy1 = JSON.parse(JSON.stringify(this.state.FlightData));

    FlightDataCopy[index]["src"] = FlightDataCopy1[index]["dest"];
    FlightDataCopy[index]["srcValue"] = FlightDataCopy1[index]["destValue"];
    FlightDataCopy[index]["dest"] = FlightDataCopy1[index]["src"];
    FlightDataCopy[index]["destValue"] = FlightDataCopy1[index]["srcValue"];

    if (
      !this.state.isAdvanceSearch &&
      this.state.selectedTripType == "roundTrip"
    ) {
      FlightDataCopy[index + 1]["src"] = FlightDataCopy1[index + 1]["dest"];
      FlightDataCopy[index + 1]["srcValue"] =
        FlightDataCopy1[index + 1]["destValue"];
      FlightDataCopy[index + 1]["dest"] = FlightDataCopy1[index + 1]["src"];
      FlightDataCopy[index + 1]["destValue"] =
        FlightDataCopy1[index + 1]["srcValue"];
    }
    this.setState({ FlightData: FlightDataCopy }, () => {
      console.log(
        "🚀 ~ file: index.js:833 ~ Theme1 ~ this.setState ~ FlightData:",
        this.state.FlightData
      );
    });
  };

  onClickOpenPassangerList = () => {
    console.log("🚀 ~ Theme1 ~ onClickOpenPassangerList:");

    this.setState({ travellerCabin: !this.state.travellerCabin }, () => {
      document.querySelector("body").style.overflow =
        this.state.travellerCabin && this.props?.isMobile ? "hidden" : "auto";
    });
  };

  onClickAirlines = () => {
    this.setState({ isAdvanceSearch: !this.state.isAdvanceSearch });
  };

  selectFareType = (ele, id) => {
    let fareoptions = this.props.FareType.map((res, idx) => {
      if (idx == id) {
        res.isChecked = !res.isChecked;
      } else {
        res.isChecked = false;
      }

      return res;
    });

    console.log(
      "🚀 ~ file: index.js:933 ~ Theme1 ~ fareoptions ~ fareoptions:",
      fareoptions
    );
    this.props.setSelectFareType(fareoptions);
    this.setState({
      FareTypeOption: ele.value,
    });
  };

  onselectTrip = (trip, id, type, closedDropdown = null) => {
    console.log(
      "🚀 ~ file: index.js:962 ~ Theme1 ~ trip:",
      trip,
      id,
      type,
      closedDropdown,
      this.state.selectedTripType
    );
    const FlightDataCopy = JSON.parse(JSON.stringify(this.state.FlightData));
    let flightArr = [];
    let flightObj = { ...FlightDataCopy[0] };
    let flightObjCopy = { ...FlightDataCopy[0] };

    this.setState({
      showMulticitySrp: false,
    });

    if (trip.value == "roundTrip" || trip.value == "Multicity") {
      console.log("multicityarti", flightObj);
      flightArr.push({ ...flightObj });
      flightArr.push({
        ...flightObj,
        dest: flightObjCopy.src,
        destValue: flightObjCopy.srcValue,
        srcValue: flightObjCopy.destValue,
        src: flightObjCopy.dest,
        departureDate: flightObjCopy.returnDate,
        returnDate: format(
          addDays(new Date(flightObjCopy.returnDate), 7),
          "dd-LLL-yyyy"
        ),
        flight: flightObj.flight + 1,
        disabledDate: flightArr[0]?.departureDate,
      });
    } else if (trip.value == "oneWay") {
      flightArr.push({ ...flightObj });
    } else {
      // flightArr.push({ ...flightObj });
      // flightArr.push({
      //   ...flightObj,
      //   disabledDate: flightArr[0].departureDate,
      // });
    }

    if (closedDropdown !== null) {
      flightArr[0][`show${type}DateDropdown`] = closedDropdown;
    }

    console.log("🚀  file: index.js:828  Theme1 ~ flightArr:", flightArr);

    this.setState({ FlightData: flightArr });

    this.setState({
      selectedTripType: trip.value,
    });
  };

  traveller = () => {
    console.log(
      "+this.state.pax.adults + +this.state.pax.child + +this.state.pax.infants",
      +this.state.pax.adults + +this.state.pax.child + +this.state.pax.infants
    );
    return (
      <div
        className={
          this.props.styles.flight_search_column +
          " " +
          this.props.styles.flight_search_class +
          " " +
          this.props.styles.wd_25
        }
      >
        <div
          className={`${this.props.styles.flight_cabin_class_cont} ${this.props.styles.trav_pd0}`}
          onClick={() => {
            this.setState({ showTraveller: !this.state.showTraveller });
          }}
          tabindex="1"
        >
          <label>Traveller</label>
          <div className={this.props.styles.advTrav_flx}>
            <div className={this.props.styles.flight_travIcon}>
              <svg width="15px" height="15px" viewBox="0 0 200 200">
                <g>
                  <path
                    fill="#30C8CA"
                    d="M100,188.716c-48.918,0-88.716-39.798-88.716-88.716S51.082,11.284,100,11.284S188.716,51.082,188.716,100 S148.918,188.716,100,188.716z M45.883,162.507c14.516,12.586,33.442,20.209,54.117,20.209c20.675,0,39.602-7.624,54.118-20.209 c-1.134-27.888-38.089-30.935-54.118-30.935S47.016,134.62,45.883,162.507z M100,17.284c-45.61,0-82.716,37.106-82.716,82.716 c0,22.237,8.82,42.452,23.146,57.331c1.983-10.823,9.079-19.279,20.815-24.682c12.708-5.85,28.09-7.077,38.755-7.077 c10.666,0,26.048,1.228,38.756,7.077c11.736,5.402,18.832,13.858,20.814,24.682c14.326-14.88,23.146-35.094,23.146-57.331 C182.716,54.39,145.609,17.284,100,17.284z M100,103c-17.409,0-31.572-14.163-31.572-31.572c0-17.409,14.163-31.572,31.572-31.572 c17.409,0,31.572,14.163,31.572,31.572C131.572,88.837,117.409,103,100,103z M100,45.856c-14.1,0-25.572,11.472-25.572,25.572 C74.428,85.528,85.9,97,100,97c14.101,0,25.572-11.472,25.572-25.572C125.572,57.328,114.101,45.856,100,45.856z"
                  ></path>
                </g>
              </svg>
            </div>
            <div
              className={`${this.props.styles.flight_cabin_class_nameAdvance} ${this.props.styles.flight_travler}`}
            >
              {`${
                +this.state.pax.adults +
                +this.state.pax.child +
                +this.state.pax.infants
              }`}
              &nbsp;Pax
            </div>
          </div>
        </div>
        {this.state.showTraveller === true ? (
          <div
            className={this.props.styles.flight_search_pax_select_main}
            ref={this.passengerDropdownWrapper}
          >
            <div
              className={
                this.props.styles.flight_search_column +
                " " +
                this.props.styles.flight_search_pax
              }
            >
              <div className={this.props.styles.flight_search_pax_newleft}>
                <label className={this.props.styles.flight_title}>Adult</label>
                <span className={this.props.styles.flight_ageLbl}>
                  (+12 Years)
                </span>
              </div>
              <PaxConfig
                value={
                  !cf.isValueEmpty(this.state.pax.adults)
                    ? +this.state.pax.adults
                    : 0
                }
                onChangePaxValue={(value, type) =>
                  this.onClickChangePaxNumber("adults", value, type)
                }
                maxLimit={9}
                minLimit={1}
                totalPax={+this.state.pax.child + +this.state.pax.adults}
                styles={this.props.styles}
              />
            </div>

            <div
              className={
                this.props.styles.flight_search_column +
                " " +
                this.props.styles.flight_search_pax
              }
            >
              <div className={this.props.styles.flight_search_pax_newleft}>
                <label className={this.props.styles.flight_title}>
                  Children
                </label>
                <span className={this.props.styles.flight_ageLbl}>
                  (2-11 Years)
                </span>
              </div>
              <PaxConfig
                value={
                  !cf.isValueEmpty(this.state.pax.child)
                    ? +this.state.pax.child
                    : 0
                }
                onChangePaxValue={(value, type) =>
                  this.onClickChangePaxNumber("child", value, type)
                }
                maxLimit={9}
                minLimit={0}
                totalPax={+this.state.pax.child + +this.state.pax.adults}
                styles={this.props.styles}
              />
            </div>

            <div
              className={
                this.props.styles.flight_search_column +
                " " +
                this.props.styles.flight_search_pax
              }
            >
              <div className={this.props.styles.flight_search_pax_newleft}>
                <label className={this.props.styles.flight_title}>Infant</label>
                <span className={this.props.styles.flight_ageLbl}>
                  (Below 2 Years)
                </span>
              </div>
              <PaxConfig
                value={
                  !cf.isValueEmpty(this.state.pax.infants)
                    ? +this.state.pax.infants
                    : 0
                }
                onChangePaxValue={(value, type) =>
                  this.onClickChangePaxNumber("infants", value, type)
                }
                maxLimit={+this.state.pax.adults}
                minLimit={0}
                totalPax={+this.state.pax.infants}
                styles={this.props.styles}
              />
            </div>
          </div>
        ) : null}
      </div>
    );
  };

  cabinClassEle = (ele, id) => {
    console.log("ele.cabinclass", ele, id);
    return (
      <div
        className={
          this.props.styles.flight_search_column +
          " " +
          this.props.styles.flight_search_class +
          " " +
          this.props.styles.wd_100
        }
        ref={(el) => {
          console.log("this.economyPopUpWrapper", this.economyPopUpWrapper);
          if (!this.economyPopUpWrapper.current)
            this.economyPopUpWrapper.current = [];
          return (this.economyPopUpWrapper.current[id] = el);
        }}
        id={`Flight_cabin_${parseInt(id)}`}
      >
        <div
          className={`${this.props.styles.flight_cabin_class_cont}`}
          // onClick={() => {this.onClickCabinClass(id)}}
        >
          <label>Cabin</label>

          <div
            className={this.props.styles.cabin_cont_flx}
            onClick={() => {
              this.onClickCabinClass(id);
            }}
          >
            <div className={this.props.styles.cabin_flx}>
              <div className={this.props.styles.flight_cabin_class_icon4}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18">
                  <path
                    fill-rule="evenodd"
                    fill="#005A95"
                    d="M12.767 15.73h-1.771v.523a1.18 1.18 0 0 1-1.18 1.181H.962v-1.181h8.854v-.523H4.785c-.534 0-1.002-1.016-1.14-1.532L1.43 4.471c-.724-1.259.023-2.554 1.283-2.891a2.36 2.36 0 0 1 2.891 1.669l1.9 7.103h5.158a2.432 2.432 0 0 1 2.454 2.124c.008.077.011.154.011.231.002 1.413-.407 3.003-2.36 3.023zm0-4.198h-6.17L4.464 3.555c-.169-.63-.816-1.004-1.284-.835-.792.169-1.04.816-.997 1.446l2.602 9.727h7.982a1.18 1.18 0 0 0 1.18-1.181c0-.102-.528-1.18-1.18-1.18zm.59-3.541a.885.885 0 1 1 0-1.77.885.885 0 0 1 0 1.77zm-.59-7.082h1.18V5.4h-1.18V.909z"
                  />
                </svg>
              </div>
              <div className={this.props.styles.flight_cabin_class_nameAdvance}>
                {!cf.isValueEmpty(ele.advancesearch.cabinclass)
                  ? ele.advancesearch.cabinclass.label
                  : ""}
              </div>
            </div>
            <div className={this.props.styles.flight_cabin_arrowMn}>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="8">
                <path
                  fill-rule="evenodd"
                  fill="#01445F"
                  d="M11.606.458c.704-.008 1.103.082 1.515.021a1.073 1.073 0 0 1-.021 1.517L7.746 7.198l-.747-.769.748.772a1.072 1.072 0 0 1-1.554-.061L.942 1.996A1.074 1.074 0 0 1 .921.479C1.334.54 2.12.45 2.437.458L7.2 4.931 11.606.458z"
                />
              </svg>
            </div>
          </div>

          {ele.advancesearch.showCabinClassList ? (
            <div
              className={this.props.styles.flight_cabin_class_list}
              tabindex="1"
            >
              {cabinClass.map((element, index) => {
                return (
                  <label
                    key={"cabinClass" + index}
                    className={
                      this.props.styles.flight_cabin_class_ele +
                      " " +
                      this.props.styles.CabinLabel
                    }
                    onClick={() => {
                      this.onChangeCabinClassValue(element, id);
                    }}
                  >
                    <input
                      type="radio"
                      checked={
                        element.label === ele.advancesearch?.cabinclass?.label
                          ? true
                          : false
                      }
                    />
                    <span className={this.props.styles.classTitle}>
                      {element.label}
                    </span>
                  </label>
                );
              })}
            </div>
          ) : null}
        </div>
        {ele.error.rbdCabinErrMsg ? (
          <span className={this.props.styles.rbderr}>
            {ele.error.rbdCabinErrMsg}
          </span>
        ) : null}
      </div>
    );
  };

  RBDClassDropdown = (index) => {
    const { FlightData } = this.state;
    const options = FlightData[index]?.advancesearch?.fcs;
    console.log("🚀 ~ file: index.js:830 ~ options:", options);

    return (
      <MultiSelectDropDown
        style={this.props.styles}
        inputPlaceHolder={"Select RBD Class"}
        dropdownInputPlaceHolder={"Type here RBD"}
        options={options}
        setoptions={(newOptions) => {
          console.log(
            "🚀 ~ file: index.js:1129 ~ Theme1 ~ newOptions:",
            newOptions,
            index
          );

          let updatedData = JSON.parse(JSON.stringify(FlightData));
          console.log(
            "🚀 ~ file: index.js:1130 ~ Theme1 ~ updatedData:",
            updatedData
          );
          // updatedData[index] = {
          //   ...updatedData[index],
          //   advancesearch: {
          //     ...updatedData[index]?.advancesearch,
          //     fcs: newOptions,
          //     cabinclass: newOptions.some((opt) => opt.isChecked) ? {} : { label: "Economy", id: 1 }
          //   },
          // };
          updatedData = updatedData.map((el, id) => {
            return {
              ...el,
              advancesearch: {
                ...el?.advancesearch,
                fcs: index == id ? newOptions : el.advancesearch.fcs,
                cabinclass: {},
              },
            };
          });
          this.setState({ FlightData: updatedData }, () => {
            console.log(
              "🚀 ~ file: index.js:1130 ~ Theme1 ~ updaghhtedData:",
              this.state.FlightData
            );
          });
        }}
      />
    );
  };

  AirlineClassDropdown = (index) => {
    const { FlightData } = this.state;
    const options = FlightData[index]?.advancesearch?.airlines;

    return (
      <MultiSelectDropDown
        style={this.props.styles}
        inputPlaceHolder={"Select Airline"}
        dropdownInputPlaceHolder={"Type here Airline"}
        options={options}
        setoptions={(newOptions) => {
          const updatedData = JSON.parse(JSON.stringify(FlightData));
          updatedData[index] = {
            ...updatedData[index],
            advancesearch: {
              ...updatedData[index]?.advancesearch,
              airlines: newOptions,
            },
          };
          this.setState({ FlightData: updatedData });
        }}
      />
    );
  };
  onClickTraveller = () => {
    if (!this.state.openTraveler) {
      this.setState({ openTraveler: true });
    } else {
      this.setState({ openTraveler: false });
    }
  };
  DepartureTimeDropdown = (index) => {
    const { FlightData } = this.state;
    let departureOption = FlightData[index]?.advancesearch?.dtym;
    return (
      <MultiSuppilerDropDownoption
        options={departureOption}
        setoptions={(newOptions) => {
          const updatedData = JSON.parse(JSON.stringify(FlightData));
          updatedData[index] = {
            ...updatedData[index],
            advancesearch: {
              ...updatedData[index]?.advancesearch,
              dtym: newOptions,
            },
          };
          this.setState({ FlightData: updatedData });
        }}
        inputPlaceHolder={"Departure Time"}
        style={this.props.styles}
        box={this.box}
      />
    );
  };

  travellerCabinEle = () => {
    console.log(
      "testt",
      +this.state.pax.adults + +this.state.pax.child + +this.state.pax.infants
    );
    return (
      <>
        <div className={this.props.styles.trav_mainCont}>
          <div
            className={`${this.props.styles.flight_search_column} ${this.props.styles.flight_cabin_class_cont} ${this.props.styles.pd_10}`}
            onClick={() => this.onClickOpenPassangerList()}
            tabindex="1"
            onFocus={() => {
              this.onClickOpenPassangerList();
            }}
          >
            <div
              className={`${this.props.styles.flight_trav_title}`}
              onClick={() => this.onClickOpenPassangerList()}
            >
              {" "}
              Travellers | Class
            </div>
            <div className={this.props.styles.trave_flx}>
              {/* <div className={this.props.styles.icon_box_adv}>
              <svg width="15px" height="15px" viewBox="0 0 200 200"><g><path fill="#30C8CA" d="M100,188.716c-48.918,0-88.716-39.798-88.716-88.716S51.082,11.284,100,11.284S188.716,51.082,188.716,100 S148.918,188.716,100,188.716z M45.883,162.507c14.516,12.586,33.442,20.209,54.117,20.209c20.675,0,39.602-7.624,54.118-20.209 c-1.134-27.888-38.089-30.935-54.118-30.935S47.016,134.62,45.883,162.507z M100,17.284c-45.61,0-82.716,37.106-82.716,82.716 c0,22.237,8.82,42.452,23.146,57.331c1.983-10.823,9.079-19.279,20.815-24.682c12.708-5.85,28.09-7.077,38.755-7.077 c10.666,0,26.048,1.228,38.756,7.077c11.736,5.402,18.832,13.858,20.814,24.682c14.326-14.88,23.146-35.094,23.146-57.331 C182.716,54.39,145.609,17.284,100,17.284z M100,103c-17.409,0-31.572-14.163-31.572-31.572c0-17.409,14.163-31.572,31.572-31.572 c17.409,0,31.572,14.163,31.572,31.572C131.572,88.837,117.409,103,100,103z M100,45.856c-14.1,0-25.572,11.472-25.572,25.572 C74.428,85.528,85.9,97,100,97c14.101,0,25.572-11.472,25.572-25.572C125.572,57.328,114.101,45.856,100,45.856z"></path></g></svg>
            </div> */}
              <div
                className={this.props.styles.flgtmn_flx}
                onClick={() => this.onClickOpenPassangerList()}
              >
                <div className={this.props.styles.flt_pasngrFlx}>
                  <span className={this.props.styles.flight_cabin_class_name}>
                    {`${
                      +this.state.pax.adults +
                      +this.state.pax.child +
                      +this.state.pax.infants
                    }   ${
                      +this.state.pax.adults +
                        +this.state.pax.child +
                        +this.state.pax.infants >
                      1
                        ? "Pax"
                        : "Pax"
                    }`}
                  </span>
                  <div className={this.props.styles.flt_trav_label}>
                    {this.state.travellerCabinClass?.label}
                  </div>
                </div>

                {this.props.isMobile && (
                  <span className={this.props.styles.flgtmn_arrow}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18px"
                      height="11px"
                    >
                      <path
                        fill-rule="evenodd"
                        fill="rgb(38, 106, 172)"
                        d="M17.373,2.754 L9.979,10.211 C9.840,10.351 9.679,10.453 9.507,10.522 C9.003,10.728 8.403,10.626 7.994,10.213 L0.599,2.756 C0.054,2.205 0.054,1.314 0.599,0.764 C1.145,0.214 2.029,0.214 2.574,0.764 L8.985,7.230 L15.399,0.762 C15.944,0.213 16.828,0.213 17.373,0.762 C17.919,1.313 17.919,2.204 17.373,2.754 Z"
                      ></path>
                    </svg>
                  </span>
                )}
              </div>
            </div>
          </div>

          {this.state.travellerCabin ? (
            <div
              className={
                this.props.styles.flight_search_Pax_main +
                " " +
                this.props.styles.flight_search_pax_select_main
              }
              ref={this.travellerCabin}
            >
              {this.props.isMobile ? (
                <div className={this.props.styles.mobileAddTraveller}>
                  <span
                    onClick={() => {
                      this.closedTravellerPopup("cabinTraveller");
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="24"
                    >
                      <path
                        fill-rule="evenodd"
                        fill="#FFF"
                        d="m13.444 3.241-8.815 8.747 8.817 8.749c.75.744.75 1.95 0 2.694a1.93 1.93 0 0 1-2.715 0L.566 13.343a1.89 1.89 0 0 1-.528-.99 1.891 1.891 0 0 1 .525-1.718L10.729.546a1.932 1.932 0 0 1 2.715 0 1.897 1.897 0 0 1 0 2.695z"
                      />
                    </svg>
                  </span>
                  <p>Add Traveller</p>
                </div>
              ) : null}

              {/* <div className={this.props.styles.flight_pax_title}>Traveler</div> */}
              {this.props.isMobile && (
                <>
                  <div className={this.props.styles.trav_wrap}>
                    <div
                      className={
                        // this.this.props.styles.flight_search_column +
                        // " " +
                        this.props.styles.flight_search_pax
                      }
                    >
                      <div
                        className={this.props.styles.flight_search_pax_newleft}
                      >
                        <label className={this.props.styles.flight_title}>
                          Adults
                        </label>
                        <span className={this.props.styles.flight_ageLbl}>
                          (Above 12 Years)
                        </span>
                      </div>
                      <PaxConfig
                        value={
                          !cf.isValueEmpty(this.state.pax.adults)
                            ? this.state.pax.adults
                            : 0
                        }
                        onChangePaxValue={(value, type) =>
                          this.onClickChangePaxNumber("adults", value, type)
                        }
                        maxLimit={9}
                        minLimit={1}
                        totalPax={
                          +this.state.pax.child + +this.state.pax.adults
                        }
                        styles={this.props.styles}
                        showDoubleDigit={this.props.isMobile ? true : false}
                      />
                    </div>

                    <div className={this.props.styles.flight_search_pax}>
                      <div
                        className={this.props.styles.flight_search_pax_newleft}
                      >
                        <label className={this.props.styles.flight_title}>
                          Children
                        </label>
                        <span className={this.props.styles.flight_ageLbl}>
                          (Age 12 years & below)
                        </span>
                      </div>
                      <PaxConfig
                        value={
                          !cf.isValueEmpty(this.state.pax.child)
                            ? this.state.pax.child
                            : 0
                        }
                        onChangePaxValue={(value, type) =>
                          this.onClickChangePaxNumber("child", value, type)
                        }
                        maxLimit={9}
                        minLimit={0}
                        totalPax={
                          +this.state.pax.child + +this.state.pax.adults
                        }
                        styles={this.props.styles}
                        showDoubleDigit={this.props.isMobile ? true : false}
                      />
                    </div>

                    <div className={this.props.styles.flight_search_pax}>
                      <div
                        className={this.props.styles.flight_search_pax_newleft}
                      >
                        <label className={this.props.styles.flight_title}>
                          Infant
                        </label>
                        <span className={this.props.styles.flight_ageLbl}>
                          (Below 2y)
                        </span>
                      </div>
                      <PaxConfig
                        value={
                          !cf.isValueEmpty(this.state.pax.infants)
                            ? this.state.pax.infants
                            : 0
                        }
                        onChangePaxValue={(value, type) =>
                          this.onClickChangePaxNumber("infants", value, type)
                        }
                        maxLimit={+this.state.pax.adults}
                        minLimit={0}
                        totalPax={this.state.pax.infants}
                        styles={this.props.styles}
                        showDoubleDigit={this.props.isMobile ? true : false}
                      />
                    </div>
                  </div>

                  <div className={this.props.styles.class_wrap}>
                    {
                      <div
                        // ref={this.economyPopUpWrapper}
                        className={
                          this.props?.styles?.flight_cabin_class_list_them
                        }
                      >
                        {cabinClass.map((element, index) => {
                          return (
                            <div
                              className={`${this.props?.styles?.flight_cabin_bxd} ${this.props.styles.active_way}`}
                            >
                              <input
                                type="radio"
                                className={this.props?.styles?.pax_input}
                                checked={
                                  element.label ===
                                  this.state.travellerCabinClass?.label
                                }
                                onClick={() => {
                                  this.setState({
                                    travellerCabinClass: element,
                                  });
                                }}
                                id={element.label}
                                value={element.label}
                              />
                              <label>{element.label} </label>
                            </div>
                          );
                        })}
                      </div>
                    }

                    <div className={this.props.styles.pax_btn_thme}>
                      <button
                        onClick={() => {
                          this.onClickOpenPassangerList();
                        }}
                      >
                        {" "}
                        Apply
                      </button>
                    </div>
                  </div>
                </>
              )}

              {!this.props.isMobile && (
                <>
                  <div className={this.props.styles.trav_wrap}>
                    <div
                      className={
                        // this.this.props.styles.flight_search_column +
                        // " " +
                        this.props.styles.flight_search_pax
                      }
                    >
                      <div
                        className={this.props.styles.flight_search_pax_newleft}
                      >
                        <label className={this.props.styles.flight_title}>
                          Adult
                          {/* (s) */}
                        </label>
                        <span className={this.props.styles.flight_ageLbl}>
                          (12y +)
                        </span>
                      </div>
                      <PaxConfig
                        value={
                          !cf.isValueEmpty(this.state.pax.adults)
                            ? this.state.pax.adults
                            : 0
                        }
                        onChangePaxValue={(value, type) =>
                          this.onClickChangePaxNumber("adults", value, type)
                        }
                        maxLimit={9}
                        minLimit={1}
                        totalPax={
                          +this.state.pax.child + +this.state.pax.adults
                        }
                        styles={this.props.styles}
                      />
                    </div>

                    <div className={this.props.styles.flight_search_pax}>
                      <div
                        className={this.props.styles.flight_search_pax_newleft}
                      >
                        <label className={this.props.styles.flight_title}>
                          Children
                          {/* (s) */}
                        </label>
                        <span className={this.props.styles.flight_ageLbl}>
                          (2y - 12y)
                        </span>
                      </div>
                      <PaxConfig
                        value={
                          !cf.isValueEmpty(this.state.pax.child)
                            ? this.state.pax.child
                            : 0
                        }
                        onChangePaxValue={(value, type) =>
                          this.onClickChangePaxNumber("child", value, type)
                        }
                        maxLimit={9}
                        minLimit={0}
                        totalPax={
                          +this.state.pax.child + +this.state.pax.adults
                        }
                        styles={this.props.styles}
                      />
                    </div>

                    <div className={this.props.styles.flight_search_pax}>
                      <div
                        className={this.props.styles.flight_search_pax_newleft}
                      >
                        <label className={this.props.styles.flight_title}>
                          Infant
                          {/* (s) */}
                        </label>
                        <span className={this.props.styles.flight_ageLbl}>
                          (Below 2y)
                        </span>
                      </div>
                      <PaxConfig
                        value={
                          !cf.isValueEmpty(this.state.pax.infants)
                            ? this.state.pax.infants
                            : 0
                        }
                        onChangePaxValue={(value, type) =>
                          this.onClickChangePaxNumber("infants", value, type)
                        }
                        maxLimit={+this.state.pax.adults}
                        minLimit={0}
                        totalPax={this.state.pax.infants}
                        styles={this.props.styles}
                      />
                    </div>
                  </div>

                  <div className={this.props.styles.class_wrap}>
                    {
                      <div
                        // ref={this.economyPopUpWrapper}
                        className={
                          this.props?.styles?.flight_cabin_class_list_them
                        }
                      >
                        {cabinClass.map((element, index) => {
                          return (
                            <div
                              className={`${this.props?.styles?.flight_cabin_bxd} ${this.props.styles.active_way}`}
                            >
                              <input
                                type="radio"
                                tabindex="1"
                                className={this.props?.styles?.pax_input}
                                checked={
                                  element.label ===
                                  this.state.travellerCabinClass?.label
                                }
                                onClick={() => {
                                  this.setState({
                                    travellerCabinClass: element,
                                  });
                                }}
                                id={element.label}
                                value={element.label}
                              />
                              <label>{element.label} </label>
                            </div>
                          );
                        })}
                      </div>
                    }

                    <div className={this.props.styles.pax_btn_thme}>
                      <button
                        onClick={() => {
                          this.onClickOpenPassangerList();
                        }}
                      >
                        {" "}
                        Apply
                      </button>
                    </div>
                  </div>
                </>
              )}
            </div>
          ) : null}
        </div>
      </>
    );
  };

  render() {
    return (
      <>
        {this.props.isSRP && this.props.isMobile ? (
          <div className={this.props.styles.srpheader}>
            <span
              onClick={() => {
                this.props.modifySearchHandler();
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20px"
                height="20px"
              >
                <path
                  fill-rule="evenodd"
                  fill="rgb(255, 255, 255)"
                  d="M1.080,0.039 C0.436,0.102 -0.035,0.675 0.028,1.319 C0.055,1.598 0.182,1.858 0.385,2.053 L8.325,10.011 L0.385,17.952 C-0.075,18.410 -0.075,19.156 0.385,19.616 C0.845,20.076 1.590,20.076 2.050,19.616 L2.050,19.616 L10.008,11.657 L17.949,19.616 C18.409,20.076 19.154,20.076 19.614,19.616 C20.073,19.156 20.073,18.410 19.614,17.952 L19.614,17.952 L11.655,10.011 L19.614,2.053 C20.079,1.603 20.092,0.862 19.643,0.397 C19.411,0.157 19.087,0.027 18.754,0.039 C18.451,0.047 18.162,0.172 17.949,0.387 L10.008,8.328 L2.050,0.387 C1.828,0.163 1.524,0.036 1.208,0.039 C1.165,0.036 1.123,0.036 1.080,0.039 Z"
                />
              </svg>
            </span>
            <p>Modify Flight Search</p>
          </div>
        ) : null}
        <div
          className={`${this.props.styles.flight_mobileContainer} ${
            this.props.isSRP
              ? this.props.styles.srpwidget
              : "container-1242 mx-auto"
          }`}
          ref={this.setDropdownWrapperRef}
        >
          <div
            className={`${
              this.props.isSRP
                ? this.props.styles.srpwidget_wrap
                : this.props.styles.flight_search_wid_container
            } ${
              this.props.isSRP && this.state.selectedTripType === "Multicity"
                ? this.props.styles.srpwdgtTop
                : ""
            }`}
          >
            {/* <div className={this.props.styles.Flt_tab_dsk}>
          <svg width="20px" height="20px" viewBox="0 0 200 200">
        <path id="flight_plane" fill="#30C8CA" d="M162.701,64.601c5.82-7.803,9.318-15.904,9.336-21.692c0.068-1.552-0.313-3.091-1.1-4.432  c-0.345-0.58-0.826-1.065-1.401-1.416c-1.351-0.815-2.914-1.209-4.49-1.13c-5.772,0-13.877,3.497-21.683,9.333  c-7.65,6.284-14.791,13.166-21.354,20.579c-1.481,1.562-3.045,3.204-4.688,4.925l-16.917-5.07l0.049-0.049  c1.457-1.482,1.451-3.859-0.012-5.335l-3.052-3.057c-0.714-0.715-1.682-1.117-2.692-1.118c-1.002-0.002-1.963,0.397-2.667,1.11  l-4.571,4.573l-2.424-0.728c1.173-1.506,1.043-3.649-0.303-5.002l-3.07-3.068c-0.714-0.711-1.681-1.11-2.689-1.108  c-1.002-0.004-1.964,0.396-2.667,1.11l-4.195,4.195l-17.202-5.153c-0.399-0.117-0.813-0.176-1.229-0.174  c-1.188-0.002-2.328,0.459-3.179,1.287l-6.047,6.048c-0.671,0.658-1.055,1.555-1.064,2.495c-0.017,1.301,0.695,2.503,1.845,3.113  l36.173,20.208c0.312,0.196,0.605,0.419,0.878,0.667l10.313,10.311c-9.646,10.161-18.24,20.004-24.937,28.566  c-0.625,0.795-1.212,1.573-1.799,2.339l-27.984-2.539c-0.161-0.021-0.323-0.029-0.485-0.029c-1.294,0.024-2.531,0.537-3.464,1.433  l-2.82,2.815c-0.681,0.652-1.071,1.553-1.082,2.494c-0.005,1.361,0.792,2.598,2.034,3.152l19.687,9.354  c0.27,0.152,0.522,0.334,0.754,0.539l1.634,1.621c-0.466,1.211-0.732,2.489-0.788,3.785c-0.054,1.35,0.442,2.66,1.375,3.637  l0.071,0.063l0.019,0.013c0.975,0.922,2.28,1.411,3.62,1.358c1.285-0.06,2.552-0.322,3.754-0.782l1.658,1.654  c0.194,0.227,0.366,0.47,0.514,0.729l9.331,19.642c0.553,1.241,1.778,2.047,3.137,2.063h0.02c0.936-0.003,1.832-0.38,2.488-1.048  l2.89-2.908c0.874-0.941,1.366-2.175,1.38-3.459c0-0.16,0-0.283-0.012-0.349l-2.548-28.082c0.769-0.577,1.542-1.173,2.34-1.791  c8.575-6.708,18.429-15.31,28.562-24.94l10.32,10.327c0.254,0.272,0.479,0.569,0.674,0.886l20.17,36.107  c0.902,1.723,3.027,2.387,4.75,1.484c0.326-0.172,0.623-0.393,0.881-0.655l6.092-6.086c0.807-0.86,1.252-1.997,1.247-3.177  c0-0.403-0.058-0.805-0.168-1.19l-5.153-17.204l4.192-4.201c1.472-1.479,1.472-3.869,0-5.348l-3.074-3.072  c-1.349-1.352-3.493-1.486-5-0.313l-0.728-2.412l4.576-4.574c0.705-0.715,1.103-1.679,1.104-2.684  c0.004-1.002-0.395-1.963-1.104-2.667l-3.061-3.062c-1.477-1.484-3.876-1.492-5.359-0.017c-0.007,0.006-0.013,0.012-0.017,0.017  l-0.032,0.029l-5.064-16.916c1.748-1.668,3.416-3.252,5-4.752C151.367,77.178,157.994,70.891,162.701,64.601z"/>
        </svg>
            Flight</div> */}
            <div className="flight_search_wid_main">
              <div className={this.props.styles.flight_way_tab}>
                <div
                  className={`${this.props.styles.flight_way_btngrp} ${this.props.styles.radio_cont}`}
                >
                  {/* flight tabs trip */}

                  {this.state.tripTypeArr.map((trip, id) => {
                    return (
                      <label
                        className={`${this.props.styles.radio_button} ${
                          trip.value === this.state.selectedTripType
                            ? this.props.styles.radio_active
                            : ""
                        }`}
                        // className={
                        //   trip.value === this.state.selectedTripType
                        //     ? this.props.styles.active_way
                        //     : Cbutton_style
                        // }
                        onClick={() => {
                          this.onselectTrip(trip, id);
                        }}
                      >
                        <input
                          type="radio"
                          value={trip.value}
                          checked={trip.value === this.state.selectedTripType}
                        />
                        {trip.label}
                        <span></span>
                        {/* <label>{trip.label}</label> */}
                      </label>
                    );
                  })}
                  {/* flight tabs trip end */}
                </div>
              </div>

              {/* { this.props.isSRP  && !this.props.isMobile  && this.state.selectedTripType == "Multicity"   ? <MulticitySrp 
                styles ={this.props.styles}
                travellerCabinEle= { this.travellerCabinEle}
                FlightData =  {this.state.FlightData }
                showmulticity ={ this.showmulticity}

              /> : null} */}

              <div
                className={`${
                  this.props.styles.flight_search_details_container
                } ${
                  this.state.selectedTripType === "Multicity"
                    ? this.props.styles.fltMulticity_container
                    : ""
                }`}
              >
                <div className={this.props.styles.flight_search_details_main}>
                  {this.state.FlightData &&
                    this.state.FlightData.map((ele, id) => {
                      console.log("🚀 ~ ele766666666666:", ele, id);
                      if (
                        this.state.selectedTripType === "roundTrip" &&
                        id == 1 &&
                        this.state.isAdvanceSearch === false
                      ) {
                        return <></>;
                      }
                      return (
                        <>
                          <div
                            className={
                              this.state.isAdvanceSearch
                                ? this.props.styles.advance_flx
                                : ""
                            }
                          >
                            <div
                              className={`${
                                this.props.styles.flight_search_details_row
                              } ${this.props.styles.flight_widgetContainer} 
                            ${
                              this.state.selectedTripType === "Multicity"
                                ? this.props.styles.fltMulticity_Card
                                : ""
                            }`}
                            >
                              {/* { this.props.isSRP  && this.state.selectedTripType == "Multicity"  && !this.props.isMobile  ?<p>Trip {id + 1}</p>: null } */}
                              <div
                                className={
                                  this.props.styles.flight_search_column +
                                  " " +
                                  this.props.styles
                                    .flight_search_depart_multicity +
                                  " " +
                                  this.props.styles.fltFrom_multicity
                                }
                              >
                                <FlightAutoComplete
                                  label="From"
                                  value={ele.src}
                                  subTitle={ele.srcValue}
                                  onclickFlightAutoComplete={() =>
                                    this.onclickFlightAutoComplete("src", id)
                                  }
                                  styles={this.props.styles}
                                  state={this.state}
                                  placholder="City or Airport"
                                  onClickSourceAndDestination={(
                                    airPortCode,
                                    city,
                                    airPortName,
                                    valueObj
                                  ) =>
                                    this.onClickSetDepartureGoingToValue(
                                      airPortCode,
                                      city,
                                      airPortName,
                                      "src",
                                      id,
                                      valueObj
                                    )
                                  }
                                  onChangeSourceAndDestination={(value) =>
                                    this.onChangeSetDepartureGoingToValue(
                                      value,
                                      "src",
                                      id
                                    )
                                  }
                                  isAutoCompleteExpand={(bool) => {
                                    this.expandAutoComplete(bool, "src", id);
                                  }}
                                  autoCompleteData={
                                    this.props.getDepartureSuggestionList || []
                                  }
                                  expandAutoCompleteBool={
                                    ele.showsrcDropdown || false
                                  }
                                  // leftIcon={<svg width="26" height="17"><path fill-rule="evenodd" fill="#01445F" d="M23.819 6.123 8.442 12.885a1.015 1.015 0 0 1-.331.07.93.93 0 0 1-.474-.152L.924 8.43c-.126-.475-.225-.595-.285-.736-.179-.415.013-.897 1.031-1.076l1.294-.819a.82.82 0 0 1 .682 0L8.414 8.96l4.689-2.67-6.46-3.581a.817.817 0 0 1-.376-.398c.583-.413.004-.897.417-1.08l2.253-.99a.79.79 0 0 1 .589-.029L19.64 3.401l2.327-1.282a2.296 2.296 0 0 1 1.807 0c1.75.676 1.754 3.292.045 4.004zm-.695-2.505a.67.67 0 0 0-.52 0L19.456 5.5c-.191.42.024-.393-.609-.04L9.305 1.857l-.389.443 6.456 3.053a.82.82 0 0 1 .221 1.294.996.996 0 0 1-.266.184L8.72 9.746a.866.866 0 0 1-.266.061c-.14.011-.281-.014.006-.074L3.278 7.441l.052.098 4.875 3.66 14.919-6.587a.54.54 0 0 0 .265-.266c.128.374.009-.601-.265-.728zM1.398 15.35h22.895a.818.818 0 0 1 0 1.637H1.398a.819.819 0 0 1 0-1.637z"></path></svg>}
                                  errorMessage={ele.error.srcErrMsg}
                                  isError={ele.error.srcErrMsg ? true : false}
                                  listWrapper={this.departureListWrapper}
                                  id={id}
                                  Header={"Source"}
                                  isMobile={this.props?.isMobile}
                                  popupClosed={() => {
                                    this.popupClosed(id, "src");
                                  }}
                                  selectedTripType={this.state.selectedTripType}
                                  recentData={this.state?.fromRecent}
                                />
                              </div>
                              {this.state.selectedTripType !== "Multicity" ? (
                                <span
                                  className={
                                    this.props.isSRP
                                      ? this.props.styles.srpwidget_Advance
                                      : this.props.styles.srpwidget_nrml
                                  }
                                >
                                  <span
                                    className={`${
                                      this.props.styles.flight_swapAdv
                                    }
                            ${
                              this.state.selectedTripType === "oneWay"
                                ? this.props.styles.flight_oneway
                                : ""
                            }
                            ${
                              this.state.isAdvanceSearch
                                ? this.props.styles.flight_onewayAdvance
                                : ""
                            }

                          ${
                            this.state.selectedTripType === "roundTrip"
                              ? this.props.styles.flight_roundTrip
                              : ""
                          }
                          ${
                            this.state.selectedTripType === "Multicity"
                              ? this.props.styles.flight_multicity
                              : ""
                          }`}
                                    // tabindex="1"
                                    onKeyDown={this.props.onSwapKeyDownHandler}
                                    onClick={() => {
                                      this.onClickSwap(id);
                                    }}
                                  >
                                    <svg
                                      version="1.1"
                                      id="Layer_1"
                                      x="0px"
                                      y="0px"
                                      width="200px"
                                      height="200px"
                                      viewBox="0 0 200 200"
                                    >
                                      <g>
                                        <circle
                                          fill="#FFFFFF"
                                          cx="99.508"
                                          cy="100.966"
                                          r="86"
                                        ></circle>
                                        <path
                                          fill="#266AAC"
                                          d="M99.508,189.466c-48.799,0-88.5-39.701-88.5-88.5s39.701-88.5,88.5-88.5s88.5,39.701,88.5,88.5   S148.307,189.466,99.508,189.466z M99.508,17.466c-46.042,0-83.5,37.458-83.5,83.5s37.458,83.5,83.5,83.5s83.5-37.458,83.5-83.5   S145.55,17.466,99.508,17.466z"
                                        ></path>
                                      </g>
                                      <g>
                                        <g>
                                          <g>
                                            <g>
                                              <path
                                                fill="#266AAC"
                                                d="M140.813,120.888c-0.031-0.026-0.054-0.055-0.08-0.082l-26.604-26.58      c-1.06-1.27-2.946-1.443-4.217-0.384c-1.271,1.06-1.44,2.946-0.384,4.216c0.119,0.135,0.248,0.262,0.384,0.381l21.508,21.507      H60.336c-1.654,0.087-2.924,1.498-2.838,3.15c0.081,1.535,1.305,2.758,2.838,2.838h71.083l-21.54,21.485      c-1.13,1.179-1.13,3.038,0,4.216c1.162,1.157,3.043,1.162,4.211,0l26.643-26.619      C141.895,123.897,141.934,122.05,140.813,120.888z M84.919,107.904c0.003,0.002,0.005,0.005,0.008,0.005      c1.162,1.162,3.045,1.162,4.208-0.005c1.125-1.177,1.125-3.03,0-4.211l-21.54-21.485h71.077      c1.535-0.084,2.757-1.306,2.845-2.833c0.086-1.654-1.189-3.07-2.845-3.157H67.596l21.505-21.506      c0.14-0.119,0.267-0.243,0.383-0.387c1.057-1.265,0.887-3.157-0.383-4.205c-1.268-1.062-3.157-0.889-4.213,0.378L58.283,77.081      c-0.027,0.019-0.054,0.051-0.081,0.076c-1.119,1.165-1.083,3.016,0.081,4.138L84.919,107.904z"
                                              ></path>
                                            </g>
                                          </g>
                                        </g>
                                        <g>
                                          <g>
                                            <g>
                                              <path
                                                fill="#FFFFFF"
                                                d="M111.984,153.007L111.984,153.007c-0.928,0-1.801-0.361-2.457-1.016c-1.328-1.384-1.328-3.54-0.01-4.916      l20.692-20.641H60.336c-1.819-0.096-3.243-1.519-3.337-3.312c-0.101-1.927,1.385-3.575,3.311-3.677l69.902-0.001l-20.654-20.653      c-0.127-0.111-0.271-0.253-0.404-0.403c-1.24-1.491-1.039-3.698,0.438-4.931c0.627-0.522,1.42-0.81,2.234-0.81      c1.041,0,2.02,0.458,2.688,1.257l26.66,26.634c0.635,0.658,0.973,1.522,0.954,2.438c-0.019,0.912-0.392,1.766-1.049,2.398      l-26.636,26.613C113.785,152.646,112.912,153.007,111.984,153.007z M131.42,125.435h1.209l-22.396,22.34      c-0.939,0.98-0.939,2.527,0.008,3.517c0.461,0.458,1.084,0.716,1.744,0.716l0,0c0.662,0,1.283-0.258,1.754-0.725l26.641-26.619      c0.473-0.456,0.736-1.059,0.75-1.705s-0.229-1.259-0.676-1.725l0.279-0.428l-0.354,0.354l-26.604-26.58      c-0.902-1.076-2.523-1.203-3.543-0.353c-1.055,0.88-1.197,2.456-0.318,3.512c0.095,0.108,0.21,0.22,0.329,0.325l22.385,22.382      h-72.29c-1.35,0.071-2.411,1.25-2.338,2.625c0.067,1.28,1.084,2.297,2.365,2.364H131.42z M87.029,109.28L87.029,109.28      c-0.927,0-1.799-0.361-2.455-1.018v-0.002L57.93,81.648c-1.354-1.303-1.396-3.476-0.088-4.837      c0.075-0.075,0.114-0.11,0.152-0.137l26.54-26.528c0.634-0.764,1.612-1.222,2.652-1.222c0.816,0,1.61,0.289,2.236,0.813      c0.713,0.589,1.155,1.425,1.24,2.354c0.086,0.932-0.196,1.839-0.794,2.556c-0.131,0.162-0.279,0.308-0.443,0.447L68.802,75.719      h69.871c1.955,0.102,3.443,1.753,3.343,3.683c-0.102,1.788-1.526,3.208-3.314,3.306l-69.896,0.001l20.683,20.632      c1.32,1.387,1.32,3.539,0.008,4.91C88.833,108.917,87.958,109.28,87.029,109.28z M85.131,107.409h0.003l0.146,0.146      c0.935,0.935,2.565,0.935,3.5-0.004c0.935-0.979,0.935-2.524-0.007-3.515l-22.387-22.33h72.287      c1.252-0.069,2.271-1.084,2.345-2.361c0.071-1.376-0.992-2.557-2.371-2.629H66.39l22.358-22.36      c0.146-0.126,0.252-0.229,0.348-0.348c0.432-0.517,0.633-1.164,0.571-1.828c-0.061-0.661-0.375-1.257-0.884-1.677      c-1.022-0.857-2.665-0.702-3.511,0.313L58.637,77.434l-0.435-0.278l0.36,0.346c-0.926,0.964-0.896,2.503,0.067,3.431      L85.131,107.409z"
                                              ></path>
                                            </g>
                                          </g>
                                        </g>
                                      </g>
                                    </svg>
                                  </span>
                                </span>
                              ) : (
                                ""
                              )}
                              <div
                                className={
                                  this.props.styles.flight_search_column +
                                  " " +
                                  this.props.styles
                                    .flight_search_depart_multicity +
                                  " " +
                                  this.props.styles.fltTo_multicity
                                }
                              >
                                <FlightAutoComplete
                                  label="To"
                                  value={ele?.dest}
                                  subTitle={ele?.destValue}
                                  onclickFlightAutoComplete={() =>
                                    this.onclickFlightAutoComplete("dest", id)
                                  }
                                  styles={this.props.styles}
                                  state={this.state}
                                  placholder="City or Airport"
                                  onClickSourceAndDestination={(
                                    city,
                                    airPortCode,
                                    airPortName,
                                    valueObj
                                  ) =>
                                    this.onClickSetDepartureGoingToValue(
                                      city,
                                      airPortCode,
                                      airPortName,
                                      "dest",
                                      id,
                                      valueObj
                                    )
                                  }
                                  onChangeSourceAndDestination={(value) =>
                                    this.onChangeSetDepartureGoingToValue(
                                      value,
                                      "dest",
                                      id
                                    )
                                  }
                                  isAutoCompleteExpand={(bool) => {
                                    this.expandAutoComplete(bool, "dest", id);
                                  }}
                                  autoCompleteData={
                                    this.props.getGoingToSuggestionList || []
                                  }
                                  expandAutoCompleteBool={
                                    ele.showdestDropdown || false
                                  }
                                  // leftIcon={<svg width="26" height="19"><path fill-rule="evenodd" fill="#01445F" d="M24.293 18.987H1.398a.819.819 0 0 1 0-1.637h22.895a.818.818 0 0 1 0 1.637zm-2.001-4.807L5.715 11.466a1.031 1.031 0 0 1-.316-.122c-.137-.098-.246-.231.441-.386L2.52 3.307c-.526-.141-.543-.197-.22-.447.5-.446.203-.745.649-.669l2.036.348a.823.823 0 0 1 .573.372l2.744 4.524 5.058.824-3.605-6.305a.819.819 0 0 1 .84-1.216l2.635.397c-.005.03.177.137.302.297l6.258 7.874 3.132.508c.619.107 1.958.463 1.515.985 1.099 1.521-.324 3.716-2.145 3.381zm1.458-2.479c-.776-.149-.933-.251-1.11-.283l-3.396-.553c.116-.032-.397-.137-.533-.298L12.45 2.692l-.14-.068 3.321 6.306c.039.068.068.79.086.219.105.439-.167 1.151-.607.986.29.021-.215.024-.323.009L7.66 8.986a.872.872 0 0 1-.257-.094.815.815 0 0 1-.302-.284L4.354 4.87l.596-.52 1.485 5.573 16.098 2.612a.553.553 0 0 0 .368-.078c.256-.161.335-.499.849-.756z"></path></svg>}
                                  errorMessage={ele.error.destErrMsg}
                                  // errorMessage={((ele.destValue.length && ele.srcValue.length) && (ele.srcValue === ele.destValue)) ? "Origin and destination cannot be same" : "Please enter destination city"}
                                  isError={ele.error.destErrMsg ? true : false}
                                  // airPortName={this.state.goingToAirPortName}
                                  listWrapper={this.returnListWrapper}
                                  id={id}
                                  Header={"Destination"}
                                  isMobile={this.props?.isMobile}
                                  popupClosed={() => {
                                    this.popupClosed(id, "dest");
                                  }}
                                  selectedTripType={this.state.selectedTripType}
                                  recentData={this.state?.toRecent}
                                />
                              </div>

                              <div
                                className={
                                  this.props?.isMobile
                                    ? this.props.styles.mobileflexcal
                                    : this.props.styles.desktop_div
                                }
                              >
                                {!this.props?.isMobile ? (
                                  <div
                                    className={
                                      this.props.styles.flight_search_column +
                                      " " +
                                      this.props.styles
                                        .flight_search_depart_going_date
                                    }
                                    tabindex="1"
                                  >
                                    <DesktopCalender
                                      theme="theme5"
                                      label="Departure"
                                      iconImage={
                                        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" id="Layer_1" x="0px" y="0px" width="18px" height="18px" viewBox="0 0 18 18"><path fill="#266AAC" d="M15.032,2.084h-1.453V0.676c0-0.373-0.289-0.674-0.646-0.674c-0.357,0-0.646,0.301-0.646,0.674v1.408H5.713 V0.676c0-0.373-0.289-0.674-0.646-0.674c-0.357,0-0.646,0.301-0.646,0.674v1.408H2.968C1.604,2.086,0.5,3.24,0.499,4.664v10.754 c0.001,1.425,1.105,2.579,2.469,2.58h12.064c1.363-0.001,2.467-1.155,2.469-2.58V4.664C17.499,3.24,16.395,2.086,15.032,2.084z M6.858,8.358v1.917H5.024V8.358H6.858z M9.85,8.358v1.917H8.15V8.358H9.85z M12.977,8.358v1.917h-1.835V8.358H12.977z M16.209,8.358v1.917h-1.94V8.358H16.209z M9.85,11.626v1.706H8.15v-1.706H9.85z M3.732,10.275H1.791V8.358h1.941V10.275z M1.791,11.626h1.941v1.706H1.791V11.626z M5.024,11.626h1.834v1.706H5.024V11.626z M6.858,14.682v1.967H5.024v-1.967H6.858z M8.15,14.682H9.85v1.967H8.15V14.682z M11.142,14.682h1.835v1.967h-1.835V14.682z M11.142,13.332v-1.706h1.835v1.706H11.142z M14.269,11.626h1.94v1.706h-1.94V11.626z M2.968,3.435h1.453v0.667c0,0.373,0.29,0.675,0.646,0.674 c0.356,0,0.646-0.302,0.646-0.674V3.435h6.574v0.667c0,0.373,0.289,0.675,0.646,0.675c0.356,0,0.646-0.303,0.646-0.675V3.435h1.453 c0.649,0.001,1.176,0.551,1.177,1.229v2.345H1.791V4.664C1.792,3.985,2.318,3.436,2.968,3.435z M1.791,15.418v-0.736h1.941v1.967 H2.968C2.318,16.646,1.792,16.098,1.791,15.418z M15.032,16.648h-0.764v-1.967h1.94v0.736 C16.208,16.098,15.682,16.646,15.032,16.648z"></path></svg>
                                      }
                                      styles={this.props.styles}
                                      value={ele.departureDate || ""}
                                      isdepartureDateValue={true}
                                      departureDate={ele.departureDate}
                                      onChangeDate={(value) => {
                                        this.onChangeDepartureGoingDateValue(
                                          value,
                                          "departure",
                                          id
                                        );
                                      }}
                                      // iconImage={
                                      //   <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19"><path fill-rule="evenodd" fill="#01445F" d="M11.971.693c0-.383.378-.693.846-.693.468 0 .847.31.847.693v3.039c0 .383-.379.694-.847.694-.468 0-.846-.311-.846-.694V.693zM9.697 15.226c-.05 0-.089-.056-.089-.469 0-.26.039-.47.089-.47h2.433c.5 0-.027.21-.027.47 0 .413.527.469.027.469H9.697zM2.324 9.84c-.049 0-.089-.21-.089-.469 0-.26.04-.47.089-.47h2.317c.05 0 .089.21.089.47 0 .259-.039.469-.089.469H2.324zm3.786 0c-.149 0-.189-.21-.189-.469 0-.26.04-.47.189-.47h2.217c.05 0 .09.21.09.47 0 .259-.04.469-.09.469H6.11zm3.587 0c-.05 0-.089-.21-.089-.469 0-.26.039-.47.089-.47h2.433c.5 0-.027.21-.027.47 0 .259.527.469.027.469H9.697zm3.688 0c-.05 0-.09-.21-.09-.469 0-.26.04-.47.09-.47h2.316c.05 0 .09.21.09.47 0 .259-.04.469-.09.469h-2.316zM2.324 12.533c-.049 0-.089-.209-.089.107 0-.836.04-1.046.089-1.046h2.317c.05 0 .089.21.089 1.046 0-.316-.039-.107-.089-.107H2.324zm3.786 0c-.149 0-.189-.209-.189.107 0-.836.04-1.046.189-1.046h2.217c.05 0 .09.21.09 1.046 0-.316-.04-.107-.09-.107H6.11zm3.587 0c-.05 0-.089-.209-.089.107 0-.836.039-1.046.089-1.046h2.433c.5 0-.027.21-.027 1.046 0-.316.527-.107.027-.107H9.697zm3.688 0c-.05 0-.09-.209-.09.107 0-.836.04-1.046.09-1.046h2.316c.05 0 .09.21.09 1.046 0-.316-.04-.107-.09-.107h-2.316zM2.324 15.226c-.049 0-.089-.056-.089-.469 0-.26.04-.47.089-.47h2.317c.05 0 .089.21.089.47 0 .413-.039.469-.089.469H2.324zm3.786 0c-.149 0-.189-.056-.189-.469 0-.26.04-.47.189-.47h2.217c.05 0 .09.21.09.47 0 .413-.04.469-.09.469H6.11zM4.343.693c0-.383.378-.693.846-.693.468 0 1.171.31 1.171.693v3.039c0 .383-.703.694-1.171.694-.468 0-.846-.311-.846-.694V.693zM.938 6.647H17.84V3.149c0 .161-.48-.225-.882-.304a.424.424 0 0 0-.303-.126h-1.546a.47.47 0 1 1 0-.939h1.547c.674 0 .719.154.967.402.248.248.627.59.627.967v13.507c0 .674-.379.719-.627.967s-.293.627-.967.627H1.368c-.377 0-.719-.379-.967-.627C.153 17.374 0 17.32 0 16.655V3.149c0-.377.153-.719.401-.967.248-.248.59-.402.967-.402H3.21c.071 0 .281.21.281.469 0 .26-.21.47-.281.47H1.368c-.117 0-.224.048.272.126-.653.078-.702.455-.702.304v3.498zm16.922.94H.938v9.068c0 .117.049.224.702.304-.498.401-.391.891-.272.891h15.288c.118 0 .225-.49.304-.891.42-.078.9-.185.9-.304V7.587zM7.397 2.719a.469.469 0 1 1 0-.939h3.152c.26 0 .641.21.641.469 0 .26-.381.47-.641.47H7.397z"></path></svg>
                                      // }
                                      startDate={ele.departureDate || ""}
                                      endDate={ele.returnDate || ""}
                                      startDateLimit={ele.disabledDate || ""}
                                      dateFormat={"DD-MMM-YYYY"}
                                      changeVisibility={(bool) => {
                                        this.onchangeVisibility(
                                          bool,
                                          "departure",
                                          id
                                        );
                                      }}
                                      isVisible={ele.showdepartureDateDropdown}
                                      type={"double"}
                                      doubleSelection={false}
                                      weekDay={
                                        weekday[
                                          new Date(ele.departureDate).getDay()
                                        ]
                                      }
                                    />
                                  </div>
                                ) : (
                                  <div
                                    className={
                                      this.props.styles
                                        .mob_flight_search_column +
                                      " " +
                                      this.props.styles.flight_mobile_calendar
                                    }
                                  >
                                    <div
                                      className={this.props.styles.calend_mnFlx}
                                    >
                                      <MobileCalender
                                        theme="theme5"
                                        label="Departure"
                                        headerlabel="Select Departure Date"
                                        styles={this.props.styles}
                                        value={ele?.departureDate || ""}
                                        placholder="Departure Date"
                                        onChangeDate={(value) => {
                                          this.onChangeDepartureGoingDateValue(
                                            value,
                                            "departure",
                                            id
                                          );
                                        }}
                                        startDate={ele.departureDate || ""}
                                        endDate={ele.returnDate}
                                        startDateLimit={ele.disabledDate || ""}
                                        dateFormat={"DD-MMM-YYYY"}
                                        changeVisibility={(bool) => {
                                          this.onchangeVisibility(
                                            bool,
                                            "departure",
                                            id
                                          );
                                        }}
                                        isVisible={
                                          ele.showdepartureDateDropdown
                                        }
                                        type={"double"}
                                        doubleSelection={false}
                                        totalMonths={12}
                                        DisableReturnDate={
                                          this.state.selectedTripType ==
                                          "oneWay"
                                        }
                                        // iconImage={
                                        //   <svg width="19" height="19">
                                        //     <path
                                        //       fill-rule="evenodd"
                                        //       fill="#01445F"
                                        //       d="M11.971.693c0-.383.378-.693.846-.693.468 0 .847.31.847.693v3.039c0 .383-.379.694-.847.694-.468 0-.846-.311-.846-.694V.693zM9.697 15.226c-.05 0-.089-.056-.089-.469 0-.26.039-.47.089-.47h2.433c.5 0-.027.21-.027.47 0 .413.527.469.027.469H9.697zM2.324 9.84c-.049 0-.089-.21-.089-.469 0-.26.04-.47.089-.47h2.317c.05 0 .089.21.089.47 0 .259-.039.469-.089.469H2.324zm3.786 0c-.149 0-.189-.21-.189-.469 0-.26.04-.47.189-.47h2.217c.05 0 .09.21.09.47 0 .259-.04.469-.09.469H6.11zm3.587 0c-.05 0-.089-.21-.089-.469 0-.26.039-.47.089-.47h2.433c.5 0-.027.21-.027.47 0 .259.527.469.027.469H9.697zm3.688 0c-.05 0-.09-.21-.09-.469 0-.26.04-.47.09-.47h2.316c.05 0 .09.21.09.47 0 .259-.04.469-.09.469h-2.316zM2.324 12.533c-.049 0-.089-.209-.089.107 0-.836.04-1.046.089-1.046h2.317c.05 0 .089.21.089 1.046 0-.316-.039-.107-.089-.107H2.324zm3.786 0c-.149 0-.189-.209-.189.107 0-.836.04-1.046.189-1.046h2.217c.05 0 .09.21.09 1.046 0-.316-.04-.107-.09-.107H6.11zm3.587 0c-.05 0-.089-.209-.089.107 0-.836.039-1.046.089-1.046h2.433c.5 0-.027.21-.027 1.046 0-.316.527-.107.027-.107H9.697zm3.688 0c-.05 0-.09-.209-.09.107 0-.836.04-1.046.09-1.046h2.316c.05 0 .09.21.09 1.046 0-.316-.04-.107-.09-.107h-2.316zM2.324 15.226c-.049 0-.089-.056-.089-.469 0-.26.04-.47.089-.47h2.317c.05 0 .089.21.089.47 0 .413-.039.469-.089.469H2.324zm3.786 0c-.149 0-.189-.056-.189-.469 0-.26.04-.47.189-.47h2.217c.05 0 .09.21.09.47 0 .413-.04.469-.09.469H6.11zM4.343.693c0-.383.378-.693.846-.693.468 0 1.171.31 1.171.693v3.039c0 .383-.703.694-1.171.694-.468 0-.846-.311-.846-.694V.693zM.938 6.647H17.84V3.149c0 .161-.48-.225-.882-.304a.424.424 0 0 0-.303-.126h-1.546a.47.47 0 1 1 0-.939h1.547c.674 0 .719.154.967.402.248.248.627.59.627.967v13.507c0 .674-.379.719-.627.967s-.293.627-.967.627H1.368c-.377 0-.719-.379-.967-.627C.153 17.374 0 17.32 0 16.655V3.149c0-.377.153-.719.401-.967.248-.248.59-.402.967-.402H3.21c.071 0 .281.21.281.469 0 .26-.21.47-.281.47H1.368c-.117 0-.224.048.272.126-.653.078-.702.455-.702.304v3.498zm16.922.94H.938v9.068c0 .117.049.224.702.304-.498.401-.391.891-.272.891h15.288c.118 0 .225-.49.304-.891.42-.078.9-.185.9-.304V7.587zM7.397 2.719a.469.469 0 1 1 0-.939h3.152c.26 0 .641.21.641.469 0 .26-.381.47-.641.47H7.397z"
                                        //     ></path>
                                        //   </svg>
                                        // }
                                        weekDay={
                                          weekday[
                                            new Date(ele.departureDate).getDay()
                                          ]
                                        }
                                        dateType={"departure"}
                                        calaHeadTitleDepart={"Departure Date"}
                                        calaHeadTitleReturn={"+Add Return Date"}
                                        selectTripbtn={() => {
                                          this.onselectTrip(
                                            {
                                              id: 2,
                                              value: "roundTrip",
                                              label: "Round Trip",
                                            },
                                            id,
                                            "departure",
                                            false
                                          );
                                        }}
                                        isMobile={this.props?.isMobile}
                                        triptype={this.state.selectedTripType}
                                      />

                                      <span
                                        className={this.props.styles.cal_arrow}
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="18px"
                                          height="11px"
                                        >
                                          <path
                                            fill-rule="evenodd"
                                            fill="rgb(38, 106, 172)"
                                            d="M17.373,2.754 L9.979,10.211 C9.840,10.351 9.679,10.453 9.507,10.522 C9.003,10.728 8.403,10.626 7.994,10.213 L0.599,2.756 C0.054,2.205 0.054,1.314 0.599,0.764 C1.145,0.214 2.029,0.214 2.574,0.764 L8.985,7.230 L15.399,0.762 C15.944,0.213 16.828,0.213 17.373,0.762 C17.919,1.313 17.919,2.204 17.373,2.754 Z"
                                          />
                                        </svg>
                                      </span>
                                    </div>
                                  </div>
                                )}

                                {this.state.selectedTripType !== "Multicity" &&
                                this.state.isAdvanceSearch === false ? (
                                  <>
                                    {!this.props?.isMobile ? (
                                      <div
                                        className={
                                          this.props.styles
                                            .flight_search_column +
                                          " " +
                                          this.props.styles
                                            .flight_search_depart_going_date
                                          // +
                                          // " " +
                                          // this.props.styles.wd_40
                                        }
                                        tabindex="1"
                                      >
                                        <DesktopCalender
                                          label="Return"
                                          iconImage={
                                            <svg xmlns="http://www.w3.org/2000/svg" version="1.1" id="Layer_1" x="0px" y="0px" width="18px" height="18px" viewBox="0 0 18 18"><path fill="#266AAC" d="M15.032,2.084h-1.453V0.676c0-0.373-0.289-0.674-0.646-0.674c-0.357,0-0.646,0.301-0.646,0.674v1.408H5.713 V0.676c0-0.373-0.289-0.674-0.646-0.674c-0.357,0-0.646,0.301-0.646,0.674v1.408H2.968C1.604,2.086,0.5,3.24,0.499,4.664v10.754 c0.001,1.425,1.105,2.579,2.469,2.58h12.064c1.363-0.001,2.467-1.155,2.469-2.58V4.664C17.499,3.24,16.395,2.086,15.032,2.084z M6.858,8.358v1.917H5.024V8.358H6.858z M9.85,8.358v1.917H8.15V8.358H9.85z M12.977,8.358v1.917h-1.835V8.358H12.977z M16.209,8.358v1.917h-1.94V8.358H16.209z M9.85,11.626v1.706H8.15v-1.706H9.85z M3.732,10.275H1.791V8.358h1.941V10.275z M1.791,11.626h1.941v1.706H1.791V11.626z M5.024,11.626h1.834v1.706H5.024V11.626z M6.858,14.682v1.967H5.024v-1.967H6.858z M8.15,14.682H9.85v1.967H8.15V14.682z M11.142,14.682h1.835v1.967h-1.835V14.682z M11.142,13.332v-1.706h1.835v1.706H11.142z M14.269,11.626h1.94v1.706h-1.94V11.626z M2.968,3.435h1.453v0.667c0,0.373,0.29,0.675,0.646,0.674 c0.356,0,0.646-0.302,0.646-0.674V3.435h6.574v0.667c0,0.373,0.289,0.675,0.646,0.675c0.356,0,0.646-0.303,0.646-0.675V3.435h1.453 c0.649,0.001,1.176,0.551,1.177,1.229v2.345H1.791V4.664C1.792,3.985,2.318,3.436,2.968,3.435z M1.791,15.418v-0.736h1.941v1.967 H2.968C2.318,16.646,1.792,16.098,1.791,15.418z M15.032,16.648h-0.764v-1.967h1.94v0.736 C16.208,16.098,15.682,16.646,15.032,16.648z"></path></svg>
                                          }
                                          styles={this.props.styles}
                                          value={ele.returnDate || ""}
                                          isgoingToDateValue={true}
                                          departureDate={ele.returnDate}
                                          onChangeDate={(value) => {
                                            this.onChangeDepartureGoingDateValue(
                                              value,
                                              "return",
                                              id
                                            );
                                          }}
                                          // iconImage={
                                          //   <svg width="19" height="19" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" fill="#01445F" d="M11.971.693c0-.383.378-.693.846-.693.468 0 .847.31.847.693v3.039c0 .383-.379.694-.847.694-.468 0-.846-.311-.846-.694V.693zM9.697 15.226c-.05 0-.089-.056-.089-.469 0-.26.039-.47.089-.47h2.433c.5 0-.027.21-.027.47 0 .413.527.469.027.469H9.697zM2.324 9.84c-.049 0-.089-.21-.089-.469 0-.26.04-.47.089-.47h2.317c.05 0 .089.21.089.47 0 .259-.039.469-.089.469H2.324zm3.786 0c-.149 0-.189-.21-.189-.469 0-.26.04-.47.189-.47h2.217c.05 0 .09.21.09.47 0 .259-.04.469-.09.469H6.11zm3.587 0c-.05 0-.089-.21-.089-.469 0-.26.039-.47.089-.47h2.433c.5 0-.027.21-.027.47 0 .259.527.469.027.469H9.697zm3.688 0c-.05 0-.09-.21-.09-.469 0-.26.04-.47.09-.47h2.316c.05 0 .09.21.09.47 0 .259-.04.469-.09.469h-2.316zM2.324 12.533c-.049 0-.089-.209-.089.107 0-.836.04-1.046.089-1.046h2.317c.05 0 .089.21.089 1.046 0-.316-.039-.107-.089-.107H2.324zm3.786 0c-.149 0-.189-.209-.189.107 0-.836.04-1.046.189-1.046h2.217c.05 0 .09.21.09 1.046 0-.316-.04-.107-.09-.107H6.11zm3.587 0c-.05 0-.089-.209-.089.107 0-.836.039-1.046.089-1.046h2.433c.5 0-.027.21-.027 1.046 0-.316.527-.107.027-.107H9.697zm3.688 0c-.05 0-.09-.209-.09.107 0-.836.04-1.046.09-1.046h2.316c.05 0 .09.21.09 1.046 0-.316-.04-.107-.09-.107h-2.316zM2.324 15.226c-.049 0-.089-.056-.089-.469 0-.26.04-.47.089-.47h2.317c.05 0 .089.21.089.47 0 .413-.039.469-.089.469H2.324zm3.786 0c-.149 0-.189-.056-.189-.469 0-.26.04-.47.189-.47h2.217c.05 0 .09.21.09.47 0 .413-.04.469-.09.469H6.11zM4.343.693c0-.383.378-.693.846-.693.468 0 1.171.31 1.171.693v3.039c0 .383-.703.694-1.171.694-.468 0-.846-.311-.846-.694V.693zM.938 6.647H17.84V3.149c0 .161-.48-.225-.882-.304a.424.424 0 0 0-.303-.126h-1.546a.47.47 0 1 1 0-.939h1.547c.674 0 .719.154.967.402.248.248.627.59.627.967v13.507c0 .674-.379.719-.627.967s-.293.627-.967.627H1.368c-.377 0-.719-.379-.967-.627C.153 17.374 0 17.32 0 16.655V3.149c0-.377.153-.719.401-.967.248-.248.59-.402.967-.402H3.21c.071 0 .281.21.281.469 0 .26-.21.47-.281.47H1.368c-.117 0-.224.048.272.126-.653.078-.702.455-.702.304v3.498zm16.922.94H.938v9.068c0 .117.049.224.702.304-.498.401-.391.891-.272.891h15.288c.118 0 .225-.49.304-.891.42-.078.9-.185.9-.304V7.587zM7.397 2.719a.469.469 0 1 1 0-.939h3.152c.26 0 .641.21.641.469 0 .26-.381.47-.641.47H7.397z"></path></svg>
                                          // }
                                          startDate={ele.departureDate || ""}
                                          endDate={ele.returnDate || ""}
                                          startDateLimit={
                                            ele.departureDate
                                              ? ele.departureDate
                                              : ele.disabledDate
                                              ? ele.disabledDate
                                              : todaysDate
                                          }
                                          // startDateLimit={ele.disabledDate || ""}

                                          dateFormat={"DD-MMM-YYYY"}
                                          changeVisibility={(bool) => {
                                            this.onchangeVisibility(
                                              bool,
                                              "return",
                                              id
                                            );
                                          }}
                                          isVisible={ele.showreturnDateDropdown}
                                          type={"double"}
                                          doubleSelection={false}
                                          DisableReturnDate={
                                            this.state.selectedTripType ==
                                            "oneWay"
                                          }
                                          triptype={this.state.selectedTripType}
                                          selectTripbtn={() => {
                                            this.onselectTrip({
                                              id: 2,
                                              value: "roundTrip",
                                              label: "Round Trip",
                                            });
                                          }}
                                          weekDay={
                                            weekday[
                                              new Date(ele.returnDate).getDay()
                                            ]
                                          }
                                          roundWayReturnClick={() => {
                                            this.onselectTrip(
                                              {
                                                id: 1,
                                                value: "oneWay",
                                                label: "One Way",
                                              },
                                              id
                                            );
                                          }}
                                          showCrossIcon={
                                            this.state.selectedTripType ==
                                            "roundTrip"
                                              ? true
                                              : false
                                          }
                                        />
                                      </div>
                                    ) : (
                                      <div
                                        className={
                                          this.props.styles
                                            .mob_flight_search_column +
                                          " " +
                                          this.props.styles
                                            .flight_mobile_calendar
                                        }
                                      >
                                        <div
                                          className={
                                            this.props.styles.calend_mnFlx
                                          }
                                        >
                                          <MobileCalender
                                            label="Return"
                                            headerlabel="Select Return Date"
                                            styles={this.props.styles}
                                            value={ele.returnDate || ""}
                                            placholder="Arrival Date"
                                            onChangeDate={(value) => {
                                              this.onChangeDepartureGoingDateValue(
                                                value,
                                                "return",
                                                id
                                              );
                                            }}
                                            startDate={ele.departureDate || ""}
                                            endDate={ele.returnDate || ""}
                                            startDateLimit={
                                              ele.departureDate
                                                ? ele.departureDate
                                                : ele.disabledDate
                                                ? ele.disabledDate
                                                : todaysDate
                                            }
                                            dateFormat={"DD-MMM-YYYY"}
                                            changeVisibility={(bool) => {
                                              this.onchangeVisibility(
                                                bool,
                                                "return",
                                                id
                                              );
                                            }}
                                            isVisible={
                                              ele.showreturnDateDropdown
                                            }
                                            type={"double"}
                                            doubleSelection={false}
                                            totalMonths={12}
                                            DisableReturnDate={
                                              this.state.selectedTripType ==
                                              "oneWay"
                                            }
                                            weekDay={
                                              weekday[
                                                new Date(
                                                  ele.returnDate
                                                ).getDay()
                                              ]
                                            }
                                            dateType={"return"}
                                            calaHeadTitleDepart={
                                              "Departure Date"
                                            }
                                            calaHeadTitleReturn={"Return Date"}
                                            selectTripbtn={() => {
                                              console.log(
                                                "fghjkll",
                                                this.state.selectedTripType
                                              );
                                              this.onselectTrip(
                                                this.state.selectedTripType ==
                                                  "oneWay"
                                                  ? {
                                                      id: 2,
                                                      value: "roundTrip",
                                                      label: "Round Trip",
                                                    }
                                                  : {
                                                      id: 1,
                                                      value: "oneWay",
                                                      label: "One Way",
                                                    },
                                                id,
                                                "return",
                                                this.state.selectedTripType ==
                                                  "oneWay"
                                                  ? true
                                                  : false
                                              );
                                            }}
                                            triptype={
                                              this.state.selectedTripType
                                            }
                                            isMobile={this.props?.isMobile}
                                          />

                                          <span
                                            className={
                                              this.props.styles.cal_arrow
                                            }
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="18px"
                                              height="11px"
                                            >
                                              <path
                                                fill-rule="evenodd"
                                                fill="rgb(38, 106, 172)"
                                                d="M17.373,2.754 L9.979,10.211 C9.840,10.351 9.679,10.453 9.507,10.522 C9.003,10.728 8.403,10.626 7.994,10.213 L0.599,2.756 C0.054,2.205 0.054,1.314 0.599,0.764 C1.145,0.214 2.029,0.214 2.574,0.764 L8.985,7.230 L15.399,0.762 C15.944,0.213 16.828,0.213 17.373,0.762 C17.919,1.313 17.919,2.204 17.373,2.754 Z"
                                              />
                                            </svg>
                                          </span>
                                        </div>
                                      </div>
                                    )}
                                  </>
                                ) : null}
                              </div>

                              {!this.props.isMobile
                                ? this.state.selectedTripType === "Multicity" &&
                                  id !== 0
                                  ? ""
                                  : this.travellerCabinEle()
                                : null}

                              {!this.props.isMobile ? (
                                <div
                                  className={this.props.styles.multicity_main}
                                >
                                  {this.state.selectedTripType ===
                                    "Multicity" &&
                                  id == this.state.FlightData.length - 1
                                    ? this.state.FlightData &&
                                      this.state.FlightData.length <= 4 && (
                                        <div
                                          className={
                                            this.props.styles
                                              .search_button_section
                                          }
                                        >
                                          <button
                                            onClick={this.AddFlightButton}
                                          >
                                            +Add Another City
                                          </button>
                                        </div>
                                      )
                                    : null}
                                </div>
                              ) : null}

                              {this.state.selectedTripType === "Multicity" &&
                              !this.state.isAdvanceSearch &&
                              id > 1 &&
                              id == this.state.FlightData.length - 1 ? (
                                <div
                                  className={
                                    this.props.styles.remove_flight_buttonMulti
                                  }
                                  style={{
                                    display: "flex",
                                    justifyContent: "end",
                                  }}
                                  id="decrease"
                                  onClick={() => {
                                    this.removeList(id);
                                  }}
                                >
                                  {this.crossIcon()}
                                </div>
                              ) : null}

                              {this.props.isMobile &&
                              ((this.state.selectedTripType === "Multicity" &&
                                id == this.state.FlightData.length - 1) ||
                                this.state.selectedTripType !== "Multicity")
                                ? this.travellerCabinEle()
                                : null}

                              {this.state.selectedTripType === "Multicity" &&
                              this.props.isMobile &&
                              id == this.state.FlightData.length - 1
                                ? this.state.FlightData &&
                                  this.state.FlightData.length <= 5 && (
                                    <div
                                      className={
                                        this.props.styles.multicity_main
                                      }
                                    >
                                      <div
                                        className={
                                          this.props.styles
                                            .search_button_section
                                        }
                                      >
                                        <button onClick={this.AddFlightButton}>
                                          +Add Another City
                                        </button>
                                      </div>
                                    </div>
                                  )
                                : null}

                              {this.props.isMobile &&
                              this.state.commomErrorMsg &&
                              this.state.selectedTripType === "Multicity" &&
                              id == this.state.FlightData.length - 1 ? (
                                <div
                                  className={
                                    this.props.styles.mobMulticity_error
                                  }
                                >
                                  <span> {this.state.commomErrorMsg} </span>
                                </div>
                              ) : null}

                              {(this.state.selectedTripType === "Multicity" &&
                                id == this.state.FlightData.length - 1) ||
                              this.state.selectedTripType !== "Multicity" ? (
                                <div
                                  className={
                                    this.props.styles.flight_Adv_wrapMU
                                  }
                                  tabindex="1"
                                  onFocus={() => {
                                    this.setState({
                                      travellerCabin: false,
                                    });
                                  }}
                                >
                                  <button
                                    className={
                                      this.props.styles.flight_AdvBtnMU
                                    }
                                    onClick={() => this.onClickSearchFlight()}
                                  >
                                    {this.props.isMobile
                                      ? "Search"
                                      : " Flight Search"}
                                  </button>
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </>
                      );
                    })}
                </div>

                {!this.props.mobileDesktop ? (
                  <div
                    className={`${this.props.styles?.popular_destination}
                  ${
                    this.props.isSRP ? this.props.styles?.popular_destiSRP : ""
                  }`}
                  >
                    <div className={this.props.styles?.Stop_wrap}>
                      <input
                        tabindex="1"
                        type="checkbox"
                        id="stop"
                        value=""
                        checked={this.state.nonStopflag == "0" ? true : false}
                        onClick={() => {
                          this.setState({
                            nonStopflag:
                              this.state.nonStopflag == "0" ? "" : "0",
                            travellerCabin: false,
                          });
                        }}
                      />
                      <label for="stop"> Non Stop Flights </label>
                    </div>
                    {/* <div>

                     
                          <div className={this.props.styles?.populardest_title}>Select A Fare Type</div> 
                           <div className={this.props.styles?.destination_container}>
                          {this.props.FareType ? this.props.FareType.map((ele, id) => {
                            return (

                                <div
                                  className={`${this.props.styles.destination_item} ${ele.isChecked
                                    ? this.props.styles.destination_active
                                    : ''
                                    }`}
                                >
                                  <div className={this.props.styles?.destination_name} onClick={() => { this.selectFareType(ele, id) }}>{ele.label}</div>
                                </div>
                              
                            )
                          }) : null}
                          </div> */}
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
